/**
 * @Author: Kamil Michalak(k.michalak@kstudio.pl)
 * @Create Time: 2019 - 10
	* @Modified by: Kamil Michalak(k.michalak@kstudio.pl)
 * @Modified time: 2019 - 11
**/

import { Button, CardMedia, CircularProgress, Radio, Slider, ClickAwayListener, Popper, Typography, Tooltip, Box } from "@mui/material"
import { LightTooltip } from "components/LightTooltip"
import IconButton from "@mui/material/IconButton"
//import { withStyles } from '@mui/styles'
import { alpha } from "@mui/material/styles"
import CinemaModeEnable from "img/player/cinema-mode-enable.svg"
import CinemaModeDisable from "img/player/cinema-mode-disable.svg"
//import CinemaModeDisable from "img/player/cinema-mode-disable-2.svg"
import FullscreenEnter from "img/player/fullscreenEnter.svg"
import FullscreenExit from "img/player/fullscreenExit.svg"
import VolumeOffBrowser from "@mui/icons-material/VolumeOff"
import VolumeOn from "img/player/volumeOn.svg"
import VolumeOff from "img/player/volumeOff.svg"
import Subtitles from "img/player/subtitles.svg"
import CloseIcon from '@mui/icons-material/Close'
import MoreEpisodes from "img/icons/series.svg"
import classnames from "classnames"
import { Img } from "components/Img"
import { CreateComponent } from "components/utils/CreateComponent"
import Backward10 from "img/player/backward10.svg"
import Forward10 from "img/player/forward10.svg"
import NotLive from "img/player/notLive.svg"
import LiveIndicator from "img/player/liveIndicator.svg"
import NotRecording from "img/player/notrecording.svg"
import RecordPreparing from "img/player/recordPreparing.svg"
import RecordComplete from "img/player/recordComplete.svg"
import Pause from "img/player/pause.svg"
import Play from "img/player/play_white.svg"
import PlayRed from "img/player/play.svg"
import PlayHover from "img/player/play-hover.svg"
import Restart from "img/player/restart.svg"
import { EventEmitter } from "components/utils/EventEmitter"
import React, { forwardRef, useEffect, useRef, useState, useLayoutEffect, memo } from "react"
import { useRootStore, rootStore } from "store/RootStore"
//import { fallbackImageCategory } from "store/util/fallbackImage"
// import stylesInputRange from "./playerScroll.module.css"
// import stylesVolumeInputRange from "./volumeScroll.module.css"
import { SourceTypeList } from "store/page/player/source/SourceTypeList"
import { RecordingsManager } from "scenes/Recordings/components/RecordingsManager"
import { RECORDING_OPTIONS } from "store/page/recordings/RecordingsManager"

import CloseButton from "img/player/close.svg"
import CloseButtonHover from "img/player/close-hover.svg"
import { isIpad, isPhoneSize, isIphone, isAndroid, isSafari, screenInfo, beep } from "utils/Utils"
import { observer } from "mobx-react-lite"
import { PauseAd } from "./components/PauseAd"
import { PositionStateMonitorUi } from "./components/FFAdAnimatedIcon"
import { AdCounter } from "./components/AdCounter"

import JumpB from "img/player/jumpB.svg"
import JumpC from "img/player/jumpC.svg"
import JumpD from "img/player/jumpD.svg"
import JumpN from "img/player/jumpN.svg"
import { appFeatures } from "../../AppFeatures"
// MTVW-727
import PictureInPicture from "img/player/PiP.svg"
//import adultContent from "img/fallback/adult_content.png"
import PinLock from "img/icons/pin_protected.svg"
import {useAdultPinGuard} from "hooks/useAdultPinGuard"
import {ButtonGeneric } from "scenes/components/ButtonComponents"
import { debounce, throttle } from "lodash"
import { moment } from "store/util/moment"
import { TIME_FORMAT_BACKEND } from "store/model/Time"
import { observable, runInAction } from "mobx"
import { useResize } from "hooks/useResize"
import { PROGRESSBAR_STEPS } from "store/page/player/PlayerProgressBar"
import { channelId, eventId, startTs, endTs, isSeries, title, season, episode, episodeName } from "utils/EventHelpers"
import Velocity from "velocity-animate"
import { l10n } from "store/lang/L10n"
import "./player.css"
//import "store/page/player/videojs/PlayerVjs.css"

// GT12-SVG
//import svgCoverImg from "img/PauseAd_McDonals_Spot_Test_AdLabeling.svg"

const ID_MAIN_CONTROLLER_CONTAINER = "mainControllerContainer"
const ID_PLAYER_CONTROLLER_RESPONSIVE = "PlayerControlsResponsive"

const styles = theme => ({
	PlayerContainer: {
		//width: "100%",
		background: theme.palette.background.default
	},

	PlayerFullscreen: {
		position: "fixed",
		left: 0,
		top: 0,
		width: "100%",
		height: "100%",
		zIndex: 1200,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center"
	},
	
	PlayerLoadingWrapper: {
		width: "100%",
		height: "100%",
		position: "absolute",
		top: 0,
		left: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},

	PlayerMutedByBrowserWrapper: {
		width: "100%",
		height: "100%",
		cursor: "pointer",
		position: "absolute",
		opacity: 0.6,
		background: alpha(theme.palette.background.default, 0.8),
		top: 0,
		left: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		zIndex: 2
	},

	PlayerMutedByBrowserIcon: {
		fontSize: "120px"
	},

	PlayerWrapper: { position: "relative" },

	Player: {},

	PlayerControls: {
		position: "absolute",
		left: 0,
		bottom: 0,
		width: "100%",
		opacity: 0,
		transition: "opacity 1s ease-in-out",
		display: "flex",
		zIndex: 3,
		"&:hover": { opacity: 1, transition: "opacity 1s ease-in -out" },
		// "& img": {
		// 	filter: `drop-shadow(2px 2px 2px ${alpha(theme.palette.secondary.main, 0.9)})`
		// }
	},

	// MTV-3617: fix missing spinner in full screen
	SpinnerContainer: {
		position: "absolute",
		left: 0,
		top: "30%",
		width: "100%",
		height: "30%",
		opacity: 1,
		//transition: "opacity 1s ease-in-out",
		//display: "flex",
		zIndex: 1,
	},

	PlayerControlsResponsive: {
		position: "absolute",
		left: 0,
		top: 0,
		width: "100%",
		height: "100%",
		/*maxHeight: "100%",*/
		zIndex: 3,
		opacity: 0,
		transition: "opacity 1s ease-in-out",
		display: "flex",
		"&:hover": { opacity: 1, transition: "opacity 1s ease-in -out" },
		// "& img": {
		// 	filter: `drop-shadow(2px 2px 2px ${alpha(theme.palette.secondary.main, 0.9)})`
		// },
		"& div[id=mainControllerContainer]": {
			width: "100%",
			//height: "100%",
			justifyContent: "space-between",
		}
	},
	//MTVW-509
	// PlayerProgramInfo: {
	// 	position: "fixed",
	// 	left: 0,
	// 	bottom: "35px",
	// 	padding: "0 2%",
	// 	width: "100%",
	// 	opacity: 1,
	// 	transition: "opacity 1s ease-in-out",
	// 	background: alpha(theme.palette.background.default, 0.8),
	// 	"&:hover": { opacity: 1 },
	// 	"& p": {
	// 		textShadow: `1px 1px 1px ${alpha(theme.palette.secondary.main, 0.9)}`
	// 	}
	// },

	PlayerDefaultCover: {},

	PlayerCover: { position: "absolute", top: 0, opacity: 1, zIndex: 1, width: "100%", height: "100%" },

	PlayerBody: {
		position: "absolute",
		width: "100%",
		height: "100%",
		top: 0,
		left: 0,
		background: "black",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	adsPlayerBody: {
		position: "relative"
	},
	PlayerControlsShowControls: { opacity: 1 },

	/**/
	PlayerControlsMain: {
		// fix safari blur
		width: "inherit",
	},
	/**/

	PlayerControlsTopWrapper: {
		position: "absolute",
		top: 0,
		right: 0,
		display: "flex"
	},

	PlayerControlsMainWrapper: {
		background: `linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.01) 8.62%, rgba(0,0,0,0.04) 16.56%, rgba(0,0,0,0.09) 23.93%, rgba(0,0,0,0.16) 30.85%, rgba(0,0,0,0.23) 37.42%, rgba(0,0,0,0.31) 43.77%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.49) 56.23%, rgba(0,0,0,0.57) 62.58%, rgba(0,0,0,0.64) 69.15%, rgba(0,0,0,0.71) 76.07%, rgba(0,0,0,0.76) 83.44%, rgba(0,0,0,0.79) 91.38%, rgba(0,0,0,0.8) 100%);`,
		display: "flex",
		flexFlow: "row wrap",
		height: "100%",
		/*maxHeight: "100%",*/
		width: "100%",
		//padding: "0.2% 0.2% 0.2% 0.2%",
		paddingBottom: "10px",
		opacity: 1.0,
	},

	PlayerControlsMainWrapperFullScreen: {
		//height: "70%",
		//height: "auto",
		paddingBottom: "30px",
		margin: "auto", // MTVW-733 center controls horizontally (ultrawidescreen)
		//bottom: "calc((100vh - 100vw * 9 / 16) / 2)" // MTVW-733 center controls vertically (ultrawidescreen)
	},

	PlayerControlsMainWrapperFullScreenResponsive: {
		//height: "70%",
		//height: "auto",
		//paddingBottom: 17 // MTVW-452 minimum for iPhone
	},

	PlayerVolumeScrollIcon: {
		"flex": "0 0 auto",
		padding: "6px 4px",
		minWidth: "40px",
		height: 56,
		width: 56
	},
	PlayerVolumeScrollIconResponsive: {
		"flex": "0 0 auto",
		padding: "6px 8px",
		minWidth: "24px"
	},
	PlayerVolumeScrollBar: {
		height: 120,
		display: "flex",
		padding: "20px 8px 0px 0px",
		zIndex: 2,
		position: "absolute",
		alignItems: "center",
		justifyContent: "center",
		width: 60,
		left: 2,
		margin: "auto",
		top: -120,
	},

	PlayerControlsClose: {
		zIndex: 100,
		width: 48,
		height: 48,
		background: `url("${CloseButton}") no-repeat`,
		backgroundPosition: "center",
		backgroundSize: "32px 32px",
		"&:hover": {
			background: `url("${CloseButtonHover}") no-repeat`,
			backgroundPosition: "center",
			backgroundSize: "40px 40px",

		},
	},

	PlayerControlsMarker: {
		//marginLeft: "10px", marginRight: "10px",
		position: "absolute",
		left: 14,
		filter: `drop-shadow(2px 2px 2px ${alpha(theme.palette.secondary.main, 0.9)}) `,
		WebkitUserSelect: "none !important",
		MozUserSelect: "none !important",
		userSelect: "none !important"
	},

	PlayerControlsDisabled: { display: "flex", opacity: 0.4, cursor: "default" },

	PlayerControlSubtitlesPopper: { position: "absolute !important", top: "unset !important", left: "unset !important", bottom: "100px !important", right: "20px !important", zIndex: 10000 },

	PlayerControlSubtitlesMenu: {
		position: "relative",
		top: "100%",
		left: -16,
		display: "flex",
		height: 192,
		width: 420,
		opacity: 0.8,
		borderRadius: 8,
		background: "linear-gradient(180deg, #191919 0%, #0C0C0C 100%)"
	},

	PlayerControlSubtitlesMenuResponsive: {
		width: "100%",
		left: 0,
	},

	//MTVW-509
	// PlayerControlsInformation: {
	// 	height: 21,
	// 	//paddingLeft: 30 MTV-3394
	// },

	PlayerControlChooseAudio: {
		width: "47%",
	},

	PlayerControlChooseAudioTitle: {
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		color: "#FFFFFF",
		fontSize: 24,
		fontWeight: "bold",
		letterSpacing: 0,
		padding: "12px 16px",
	},

	PlayerControlChooseAudioTitleLeft: {
		borderRadius: "8px 0px 0px 0px",
	},

	PlayerControlChooseAudioTitleRight: {
		borderRadius: "0px 8px 0px 0px",
	},

	PlayerControlChooseSubtitles: { width: "53%" },

	PlayerControlSubtitles: {
		//padding: "6px 4px",
		//minWidth: 40,
		//height: 40,
		//width: 80,
	},

	PlayerControlSubtitlesResponsive: { padding: "6px 8px", minWidth: 24 },

	PlayerControlLanguageWrapper: {
		display: "flex",
		alignItems: "center",
		padding: "0 24px 0 10px"
	},

	//PlayerInfoButton: { fontWeight: "normal" },

	PlayerControlsRow1: {
		opacity: 1.0,
		width: "100%",
		flex: "1 1 100%",
		alignSelf: "flex-start",
		padding: "0.2% 0.2% 0.2% 0.2%",
		display: "flex",
		flexFlow: "row",
		alignItems: "center",
		justifyContent: "flex-end",
		paddingRight: 16
	},

	PlayerControlsRow1FullScreen: {},
	PlayerControlsRow1Responsive: {
		width: "100%",
		display: "flex",
		justifyContent: "flex-start",
		zIndex: 2,
		marginLeft: "24px",
		position: "relative",
		top: "5px",
	},

	PlayerControlsRow1LeftResponsive: {
		display: "flex",
		gap: 18,
		/*
		width: "100%",
		display: "flex",
		justifyContent: "flex-start",
		zIndex: 2,
		marginLeft: "8px"
		*/
	},

	PlayerControlsRow1RightResponsive: {
		display: "flex",
		gap: 18,
		position: "absolute",
		right: 16,
		marginRight: 32
		/*
		width: "100%",
		display: "flex",
		justifyContent: "flex-start",
		zIndex: 2,
		marginLeft: "8px"
		*/
	},

	PlayerControlsRow2: {
		opacity: 1.0,
		width: "100%",
		display: "flex",
		flex: "1 1 100%",
		alignSelf: "center",
		// MTVW-981: controls adjustments, commented below line
		//paddingBottom: 12,
		//marginBottom: 12, // Test iPad MTVW-710 fullscreen
	},

	PlayerControlsRow2Fullscreen: {position: "relative", /*bottom: 20*/	},
	PlayerControlsRow3Fullscreen: {position: "relative", /*bottom: 20*/},

	PlayerControlsRow3: {
		display: "flex",
		width: "100%",
		alignSelf: "flex-end",
		justifyContent: "space-between",
		height: "56px"
	},

	PlayerControlsRow3Left: {
		position: "relative",
		left: 32,
		display: "flex",
		marginTop: 5,
		gap: 18, //24
	},

	PlayerControlsRow3Animation: {
		display: "flex",
		flexFlow: "row",
		height: "inherit", //40,
		width: "inherit", //40,
		overflow: "hidden",
		alignSelf: "center",
		// paddingBottom: "2px",
		zIndex: 0
	},


	PlayerControlsRow3Center: {
		display: "flex",
		justifyContent: "flex-end",
		gap: 18,
	},

	PlayerControlsRow3CenterFullScreen: {
		//flex: "0 0 43%",
	},

	// video with >= 768px amd <= 1024px
	PlayerControlsRow3CenterFullScreenDense: {
		flex: "0 0 25%",
	},

	PlayerControlsRow3Right: {
		position: "relative",
		right: 32,
		display: "flex",
		//alignItems: "flex-end",
		//justifyContent: "flex-end",
		marginTop: 5,
		gap: 18, //24
	},

	PlayerControlLiveIndicator: { display: "flex", alignItems: "center" },

	PlayerProgressBarTextAfterFullScreen: {},

	PlayerControlsFullscreen: {
		// added to fix safari blur
		padding: "6px 4px",
		minWidth: 40,
		height: 40,
		width: 40,
	},

	PlayerProgressBarScroll: { width: "100%", position: "absolute", top: -18 },

	buttonCustomRoot: {
		minWidth: "40px !important",
		height: 40,
		width: 40,
		padding: "6px 4px"
	},

	muiButtonNoHoverEffect: {
		minWidth: "40px !important",
		height: 40,
		width: 40,
		padding: "6px 4px",
		//added to fix safari blur added
		transform: 'scale(0.8)',
		"&:hover": {
			backgroundColor: "transparent !important",
			// fix safari blur added
			// transform: 'scale(1.3)'
			transform: 'scale(1)'
		}
	},

	subtitleRadioRoot: {
		color: "white!important"
	},

	playerControlSliderThumb: {
		pointerEvents: 'none', // IMPORTANT, otherwise we get pointer events relative to the thumb
		backgroundColor: "#ffffff !important",
		marginLeft: "-0px !important",
		"&:focus, &:hover, &.Mui-active": {
			boxShadow:
				`0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02) !important`
			// Reset on touch devices, it doesn't add specificity
		},
		"&:after": {
			top: -5,
			left: -5,
			right: -5,
			bottom: 0
		}
	},

	playerControlProgressBarSliderThumb: {
		height: 24,
		width: 24,
	},

	playerControlVolumeSliderRail: {
		width: "8px !important",
		borderRadius: 4,
		opacity: 0.5,
		backgroundColor: '#bfbfbf !important',
	},

	playerControlVolumeSliderTrack: {
		width: "7px !important",
		borderRadius: 6,
	},

	playerControlProgressBarSliderRail: {
		height: "8px !important",
		borderRadius: 6,
		opacity: 1,
		backgroundColor: '#999999 !important',
	},

	playerControlProgressBarSliderTrack: {
		height: "7px !important",
		borderRadius: 4,
	},

	playerControlProgressBarLiveMark: {
		pointerEvents: 'none', // IMPORTANT, suppress for correct thumbnail positioning
		width: 16,
		height: 16,
		background: '#FFC107',
		borderRadius: 9999,
		'&.MuiSlider-markActive': {
			opacity: 0,
		},
		// MTVW-1079: add zIndex, add transform
		zIndex: "3 !important",
		transform: 'translate(-8.5px, -8px) !important',
	},

	playerControlSliderLabel: {
		marginBottom: 4,
		height: 22,
		width: 60,
		//marginLeft: "-8px !important",
		borderRadius: "20px !important",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "#FFFFFF !important",
		fontWeight: "bold",
		"& > span": {
			backgroundColor: "#FFFFFF !important",
		},
		"& > span > span": {
			color: "black !important",
		},
	},

	"@keyframes fadeAnimation": {
		from: { opacity: 1 },
		to: { opacity: 0 }
	},
	PlayerControlEventFullScreenInfoContainer: {
		animation: "$fadeAnimation 15s ease-in-out",
		position: "fixed",
		top: 16,
		left: 16,
		opacity: 1,
	},
	PlayerControlEventFullScreenInfoContainerResponsive: {
		animation: "$fadeAnimation 15s ease-in-out",
		position: "fixed",
		top: 48,
		// left: 16,
		opacity: 1,
	},

	PlayerControlEventFullScreenInfoTitle: {
		// height: 37,
		width: "50vw",
		color: "#FFFFFF",
		fontSize: 24,
		fontWeight: "bold",
		letterSpacing: 0.43,
		lineHeight: 1.5,
	},

	PlayerControlEventFullScreenInfoSubTitle: {
		// height: 20,
		width: "50vw",
		color: "rgba(255, 255, 255, 0.7)",
		fontSize: 16,
		letterSpacing: 0.28,
		lineHeight: 1.3,
	},

	playerRecordStatusIndicator: {
		padding: "0px 4px 0px 0px",
		// minWidth: 64,
		height: 56,
		width: 56,
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},

	centralPlayResumeButton: {
		height: 96,
		width: 96,
		position: "absolute !important",
		left: "50%",
		top: "50%",
		transform: "translate(-50%, -50%) scale(1.0)",
		//WebkitTransform: "translate(-50%, -50%) scale(1.0)",
		//MozTransform: "translate(-50%, -50%) scale(1.0)",
		color: theme.palette.text.primary,
		cursor: "pointer",
		zIndex: 4,
		background: `url("${PlayRed}") no-repeat`,
		backgroundPosition: "center",
		backgroundSize: "96px 96px",
		//WebkitBackgroundSize": "96px 96px",
		// MTVW-701: scale with animation
		transition: "all 250ms ease-in-out !important",
		//WebkitTransition: "all 250ms ease-in-out !important",
		//MozTransition: "all 250ms ease-in-out !important",
		"&:hover": {
			/*background: `url("${PlayHover}") no-repeat`,*/
			backgroundPosition: "center",
			// transition: ".5s  ease-in-out",
			// WebkitTransition: ".5s  ease-in-out",
			/*
			backgroundSize: "96px 96px",
			webkitBackgroundSize: "96px 96px",
			*/
			// MTVW-701: scale with animation
			transform: "translate(-50%, -50%) scale(1.1)",
			//WebkitTransform: "translate(-50%, -50%) scale(1.1)",
			//MozTransform: "translate(-50%, -50%) scale(1.1)",
		},
	},

	centralPlayResumeButtonMobile: {
		height: 48,
		width: 48,
		position: "absolute !important",
		left: "50%",
		top: "50%",
		transform: "translate(-50%, -50%)",
		color: theme.palette.text.primary,
		cursor: "pointer",
		zIndex: 4,
		background: `url("${PlayRed}") no-repeat`,
		backgroundPosition: "center",
		backgroundSize: "48px 48px",
		"&:hover": {
			background: `url("${PlayHover}") no-repeat`,
			backgroundPosition: "center",
			backgroundSize: "48px 48px",
			webkitBackgroundSize: "48px 48px",
		},
	}
})

const getWindowDimensions = () => window.innerWidth

const visibilityHelper = (bState, style = {}) => {
	return !bState ? { visibility: "hidden"/*, height: 0, width: 0, minWidth: 0, padding: 0*/ } : style
}

let controlsTimerId = null
export function controlsTimerHandler(page, disableTimeout = false) {
	//console.trace("controlsTimerHandler", disableTimeout)
	//console.debug(new Error().stack)
	// MTV-1811: prevent playing of non subscribed channel
	if (page?.error === null) {
		const adsPlayer = document.getElementById("adsPlayer")
		const pauseAd = document.getElementById("pauseAdCardMedia")
		document.body.style.zIndex = 100
		if (adsPlayer) adsPlayer.style.zIndex = 100
		if (pauseAd) pauseAd.style.zIndex = 100
		if (controlsTimerId !== null) {
			clearTimeout(controlsTimerId)
			controlsTimerId = null
			// MTVW-856: hide mouse pointer in fullscreen, don't use 'if (page.player.isFullScreen)', otherwise cursor might be behind player
			document.body.style.cursor = "default"
			if (adsPlayer) adsPlayer.style.cursor = "default"
			if (pauseAd) pauseAd.style.cursor = "default"
		}
		page.setMouseOver(true)
		// MTV-2525: add condition for isMutedByBrowser
		//if (page.player.isFullScreen) document.body.style.cursor = "none"
		if (!disableTimeout && (page.player.isMutedByBrowser === false)) {
			controlsTimerId = setTimeout(() => {
				page.setMouseOver(false)
				controlsTimerId = null
				// MTVW-856: hide mouse pointer in fullscreen
				//console.debug("recordingsStartDialog", document.getElementById("recordingsStartDialog"))
				// MTVW-892: don't hide for recordingsStartDialog
				if (page.player.isFullScreen && !document.getElementById("recordingsStartDialog")) {
					document.body.style.cursor = "none"
					if (adsPlayer) adsPlayer.style.cursor = "none"
					if (pauseAd) pauseAd.style.cursor = "none"
				}
			}, rootStore.sso.browserStore.controlsVisibleDuration)
		}
	}
}

/*
<div className="hover-container" style={{justifyContent: 'flex-start', alignItems: 'center', gap: 24, display: 'inline-flex'}}>
	<div className="hidden-div" style={{position: "absolute", width: 80, height: 80, opacity: 1, 'background': 'rgba(255, 255, 255, 0.20)', borderRadius: 9999}} />
	<div style={{width: 48, height: 48, position: 'relative', overflow: 'hidden'}}>
		<img style={{width: 40, height: 40, left: 20, top: 4, position: 'absolute'}} src={Restart} alt="" />
	</div>
</div>
*/

const ButtonCustom = CreateComponent(
	styles,
	false,
	true,
	forwardRef(({ children, isLiveIndicator =  false, isDisabled = false, isHidden = false, isStreamLoaded = null, player = true, hoverCss = true, classes, ...props }, ref) => {
		//console.debug("ButtonCustom", props.state)
		//console.debug("ButtonCustom med %s, width %s", state.isMedium, state.videoWidth, props?.["data-test"])
		const state = props.state
		
		let iconClass = "PlayerControlsIcon"
		let hoverContainerClass = "PlayerControlsHoverContainer"
		if (state.isMedium) {
			iconClass = "PlayerControlsMedIcon"
			hoverContainerClass = "PlayerControlsHoverMedContainer"
		}
		if (state.isFullScreen) {
			if (!isLiveIndicator) {
				iconClass = "PlayerControlsFsIcon"
				hoverContainerClass = "PlayerControlsHoverFsContainer"
			}
			else {
				iconClass = "PlayerControlsLiveFsIcon"
				hoverContainerClass = "PlayerControlsHoverLiveFsContainer"
			}
		}
		else if (isLiveIndicator) {
			if (state.isMedium) {
				iconClass = "PlayerControlsLiveMedIcon"
				hoverContainerClass = "PlayerControlsHoverLiveMedContainer"
			}
			else {
				iconClass = "PlayerControlsLiveIcon"
				hoverContainerClass = "PlayerControlsHoverLiveContainer"
			}
		}
		///if (props?.["data-test"] === "player_rec") console.debug("ButtonCustom", props?.["data-test"], state.videoWidth, state.isMedium, iconClass, hoverContainerClass, props)

		return state.videoWidth && (isDisabled || isStreamLoaded === false) ?
			<div className={classes.PlayerControlsDisabled}>
				<Button
					style={visibilityHelper(!isHidden)}
					ref={ref} className={hoverContainerClass}
					data-test={props["data-test"] ?? ""} data-state={props["data-state"] ?? ""}
					disableFocusRipple={true}
					disableRipple={true}
					>
						<div className={iconClass} style={{cursor: "default"}}
							onClick={(e) => {
								e.stopPropagation()}
							}
						>
							{children}
						</div>
				</Button>
			</div>
			:
			<Button
				// MTVW-1020, item 10, No recording button for non-replay channels! -> added {...props}
				style={visibilityHelper(!isHidden)} {...props}
				variant="contained"
				ref={ref} className={hoverContainerClass}
				data-test={props["data-test"] ?? ""} data-state={props["data-state"] ?? ""}
				disableFocusRipple={true}
				disableRipple={true}
				sx={{
					backgroundColor: "transparent !important",
					// disable box shadow
					boxShadow: "none !important",
					//backgroundColor: "rgba(255, 255, 255, 0.20) !important",
					 "&:hover": {backgroundColor: "rgba(255, 255, 255, 0.20) !important" },
					 //"& .MuiTouchRipple-root & .MuiTouchRipple-child": { borderRadius: "50%" },
				}}
				>
					<div className={iconClass} 
						onClick={(e) => {
							e.stopPropagation()
							//rootStore.page.Player.setMouseOver(false)
							if (props.onClick) props.onClick(e)}
						}
						/*onClick={props.onClick} {...props}>*/
					>
						{children}
					</div>
			</Button>
		}
	)
)

const ButtonJumpMarker = CreateComponent(styles, false, true, ({ state, classes, page, enabled, icon, dataTest, marker, action, ...props }) => {
	//console.debug("ButtonJumpMarker", marker, dataTest, enabled)
	return (
		<ButtonCustom
			state={state}
			isDisabled={false}
			isHidden={!enabled}
			onClick={(e) => {
				e.stopPropagation()
				e.preventDefault()
				action()
				controlsTimerHandler(page, true)
			}}
			data-test={dataTest}
		>
			<img src={icon} className={state.classImg} alt="" />
		</ButtonCustom>
	)
})

const volumeCheatHelper = val => 0 + parseInt(val, 10)

const PlayerControlAudioSubtitlesMenuItem = CreateComponent(null, false, true, ({ classes, i, checkCircleClass, ...props }) => (
	<div className={classes.PlayerControlLanguageWrapper}>
		<Radio
			checked={i.isSelected}
			onClick={(e) => { e.stopPropagation() }}
			onChange={(e) => { e.stopPropagation(); if (i.isSelectable && !i.isSelected) i.setTrack && i.setTrack() }}
			value={i.labelText}
			label={i.labelText}
			name="radio-buttons"
			classes={{ root: `${classes.subtitleRadioRoot}` }}
			slotProps={{ input: { 'aria-label': 'A' } }}
		/> {i.labelText}
	</div>
))

const PlayerControlAudioSubtitlesMenu = CreateComponent(null, false, true,

	forwardRef(({ classes, page, player, setSubtitle, isInPlayerControlsResponsive, ...props }, ref) => (
		<div
			ref={ref}
			className={!isInPlayerControlsResponsive ? classes.PlayerControlSubtitlesMenu : `${classes.PlayerControlSubtitlesMenu} ${classes.PlayerControlSubtitlesMenuResponsive}`}
			onMouseMove={() => {
				controlsTimerHandler(page, true)
			}}
			onMouseLeave={() => {
				controlsTimerHandler(page)
			}}
		>
			<div className={classes.PlayerControlChooseAudio} data-test="player_track_container_audio">
				<div className={`${classes.PlayerControlChooseAudioTitle} ${classes.PlayerControlChooseAudioTitleLeft}`}>
					{l10n.featurePlayerAudiotracks}
				</div>
				{/* {console.debug("AUDIO CONTAINER %o", player.audioTracksContainer.items)} */}

				{player.audioTracksContainer.items.map(i => (
					<PlayerControlAudioSubtitlesMenuItem classes={classes} i={i} key={i.labelText} />
				))}
				{/* MTVW-92: Handled in module PlayerTrackVo
			{!player.audioTracksContainer.items.length && (
				<PlayerControlAudioSubtitlesMenuItem
					classes={classes}
					i={{
						labelText: "Keine Information",
						isSelected: true
					}}
				/>
			)}
			*/}
			</div>
			<div className={classes.PlayerControlChooseSubtitles} data-test="player_track_container_subtitle">
				<div className={`${classes.PlayerControlChooseAudioTitle} ${classes.PlayerControlChooseAudioTitleRight}`}>{l10n.featurePlayerSubtitles}</div>
				{player.subtitleTracksContainer.items.map(i => (
					<PlayerControlAudioSubtitlesMenuItem classes={classes} i={i} key={i.labelText} />
				))}
			</div>

			{/* Add close icon for mobile audio subtile in progress */}
			<div className="closeIconAudioSubtilesResponsive" style={{ display: "none" }}>
				<Typography variant="caption">
					<Button sx={{ color: "#fff !important" }} onClick={(e) => { e.stopPropagation(); void setSubtitle(false) }}><CloseIcon /></Button>
				</Typography>
			</div>
		</div>
	)))

const getPlayerStyle = (visible) => {
	let style = null
	if (import.meta.env.VITE_PLAYER === "vjs") {
		style = { display: visible ? "block" : "none" }
	}
	else if (import.meta.env.VITE_PLAYER === "vo") {
		style = { display: visible ? "block" : "none", position: "relative", }
	}
	return style
}

const PlayerProgressBarWrapper = CreateComponent(null, false, true, ({ classes, page, source, player }) => {
	// =========================================================
	// Resolve effective inputs first (never mutate props)
	// =========================================================

	// MTVW-444: display values for playerFg while playerBg loading
	const effectivePlayer = page?.playerFg || player
	const effectiveSource = page?.playerFg?._source || source

	// MTVW-1101: prevent crash (Rendered fewer hooks than expected)
	// All hooks must run before any conditional return
	const shouldRender = !!(effectivePlayer?.isStreamLoaded && effectiveSource)
	const progressBar = effectiveSource?.progressBar

	// =========================================================
	// Hooks (must always run, never below early return)
	// =========================================================

	const sliderRect = useRef(null)
	const progressBefore = useRef(null)
	const progressBeforeRect = useRef(null)
	const progressAfter = useRef(null)
	const progressAfterRect = useRef(null)
	const bodyInnerRect = useRef(null)
	const thumbnailContainer = useRef(null)

	const thumbsRef = useRef([])
	const vWidth = useRef(getWindowDimensions())
	const thumbstyleRef = useRef({})

	const rafRef = useRef(null)
	const loadingRef = useRef(false)
	const loadDebounceRef = useRef(null)
	const hoverSessionRef = useRef(0)
	const isHoveringRef = useRef(false)
	const lastThumbIxRef = useRef(null)
	const lastTargetTsRef = useRef(null)
	const lastOffsetXRef = useRef(0)
	const imageCacheRef = useRef(new Map())
	const loadingRefSet = useRef(new Set())
	const errorCountRef = useRef(new Map())
	const imgRef = useRef(null)

	const [thumbInfo, setThumbInfo] = useState({ thumbIx: null, left: 0 })
	const [isHovering, setIsHovering] = useState(false)
	const [isLoaded, setIsLoaded] = useState(false)
	const THUMB_STEP = 10000 // 10 seconds

	const setThumbs = (data) => {
		thumbsRef.current = data
	}

	const isLive = effectiveSource?.type === SourceTypeList.ChannelLive

	const isNearLive =
		effectiveSource?.type === SourceTypeList.ChannelLive ||
		moment().utc().valueOf() <= effectiveSource?.playlist?.end

	const liveOffset = isSafari() ? 0 /*16000*/ : isNearLive ? 40000 : 0 // 65000 : 10000

	// =========================================================
	// Slider change
	// =========================================================

	const onChange = throttle((progressBar, val, done, thumbTs) => {
		if (!progressBar?.isVisible) return

		progressBar?.setPosition(val, done, thumbTs)

		if (!sliderRect.current || !progressBeforeRect.current || !progressAfterRect.current) return

		// MTVW-1020, item 3, item 7: hide textBefore and textAfter when dragging the slider
		const offsetX = (sliderRect.current.width / PROGRESSBAR_STEPS) * val
		//console.debug("onChange", offsetX, done, e?.type, e?.touches)
		const tooltipHalfWidth = 30 //28
		// check if textBefore or textAfter are in the way
		page.setDragOnProgressBar(!done)
		if (!done) {
			if (progressBefore.current) {
				//console.debug("HIT Before", offsetX <= progressBeforeRect.current.width + tooltipHalfWidth, progressBeforeRect.current.width, done)
				progressBefore.current.style.visibility =
					offsetX <= progressBeforeRect.current.width + tooltipHalfWidth ? "hidden" : "visible"
			}

			if (progressAfter.current) {
				//console.debug("HIT after", offsetX >= sliderRect.current.width - (progressAfterRect.current.width + tooltipHalfWidth), progressAfterRect.current.width, done)
				progressAfter.current.style.visibility =
					offsetX >= sliderRect.current.width - (progressAfterRect.current.width + tooltipHalfWidth)
						? "hidden"
						: "visible"
			}
		}
		else {
			if (progressBefore.current) progressBefore.current.style.visibility = "visible"
			if (progressAfter.current) progressAfter.current.style.visibility = "visible"
		}
	}, 50)

	const handleMouseUp = () => {
		if (progressBefore.current) progressBefore.current.style.visibility = "visible"
		if (progressAfter.current) progressAfter.current.style.visibility = "visible"
	}

	// =========================================================
	// Thumbnail helpers
	// =========================================================

	const findThumbIndex = (thumbs, targetTs) => {
		let lo = 0
		let hi = thumbs.length - 1

		while (lo <= hi) {
			const mid = (lo + hi) >> 1
			const ts = Number(thumbs[mid].ts)

			if (ts < targetTs) lo = mid + 1
			else hi = mid - 1
		}

		if (lo <= 0) return 0
		if (lo >= thumbs.length) return thumbs.length - 1

		const prev = Number(thumbs[lo - 1].ts)
		const next = Number(thumbs[lo].ts)

		return Math.abs(prev - targetTs) < Math.abs(next - targetTs) ? lo - 1 : lo
	}

	
	// -----------------------------
	// image cache
	// -----------------------------

	const preloadThumb = (ix) => {
		const thumbs = thumbsRef.current
		const t = thumbs?.thumbs?.[ix]
		if (!t) return
		if (Number(t.ts) < startTs(effectiveSource.Event) || Number(t.ts) > moment().utc().valueOf() - liveOffset) {
			return
		}
		//else console.debug("preload thumb", ix, t.id, Number(t.ts), Number(t.ts) - (moment().utc().valueOf() - liveOffset))

		const url = thumbs.url + t.id

		if (imageCacheRef.current.has(url)) return
		if (loadingRefSet.current.has(url)) return

		const errorCount = errorCountRef.current.get(url) || 0
		if (errorCount > 2) return

		loadingRefSet.current.add(url)

		const img = new Image()
		//img.width = 400
		//img.height = 225
		img.loading = "lazy"              // ✅ LOW priority
		img.fetchPriority = "low"         // ✅ LOW priority
		img.src = url

		img.onload = () => {
			//console.debug("thumb loaded", url)
			loadingRefSet.current.delete(url)
			imageCacheRef.current.set(url, img)
			errorCountRef.current.delete(url)
		}

		img.onerror = (e) => {
			console.warn("thumb error", e, url)
			loadingRefSet.current.delete(url)
			errorCountRef.current.set(url, errorCount + 1)
		}
	}

	const preloadDirectional = (targetIx) => {
		const lastIx = lastThumbIxRef.current
		const dir = lastIx == null ? 0 : Math.sign(targetIx - lastIx)

		// always load current
		preloadThumb(targetIx)

		// only ONE neighbor (directional)
		if (dir > 0) preloadThumb(targetIx + 1)
		else if (dir < 0) preloadThumb(targetIx - 1)
	
		// IMPORTANT: always update
		lastThumbIxRef.current = targetIx
	}

	// -----------------------------
	// compute + update
	// -----------------------------

	const updateThumbFromTs = (targetTs, offsetX) => {
		const thumbsObj = thumbsRef.current
		if (!thumbsObj?.thumbs?.length || !sliderRect.current) return
		if (targetTs >= moment().utc().valueOf() - liveOffset || targetTs < startTs(effectiveSource.Event)) {
			setThumbInfo({ thumbIx: null, left: 0 })
			return
		}

		const thumbs = thumbsObj.thumbs
		const targetIx = findThumbIndex(thumbs, targetTs)
	
		// 🚫 prevent spamming same index
		// (lastThumbIxRef.current === targetIx) return
		// < 2 would limit thumbs to 20s interval
		if (lastThumbIxRef.current !== null && Math.abs(lastThumbIxRef.current - targetIx) < 1) return

		// -----------------------------
		// position (UI must update immediately)
		// -----------------------------
		const sliderWidth = sliderRect.current.width

		const horizontalOffset =
			vWidth.current < 540 ? (0.5 * 400) / 2 :
			vWidth.current < 768 ? (0.65 * 400) / 2 :
			400 / 2

		//const mouseDown = event.buttons === 1
		/* MTVW-1020, item 3, item 7: hide textBefore and textAfter when dragging the slider, MOVED to onChange
			because slider thumb can be dragged if mouse is moved vertially outside
		const tooltipHalfWidth = 28
		//console.debug("onChange move", offsetX)
		// check if textBefore or textAfter are in the way
		if (!progressBar.positionDone) {
			if (offsetX <= progressBeforeRect.current.width + tooltipHalfWidth) {
				//console.debug("HIT Before", offsetX <= progressBeforeRect.current.width + tooltipHalfWidth, progressBeforeRect.current.width, progressBar.positionDone)
				progressBefore.current.style.visibility = "hidden"
			}
			else progressBefore.current.style.visibility = "visible"
			if (offsetX >= sliderRect.current.width - (progressAfterRect.current.width + tooltipHalfWidth)) {
				//console.debug("HIT after", offsetX >= sliderRect.current.width - (progressAfterRect.current.width + tooltipHalfWidth), progressAfterRect.current.width, progressBar.positionDone)
				progressAfter.current.style.visibility = "hidden"
			}
			else progressAfter.current.style.visibility = "visible"
		}
		else {
			progressBefore.current.style.visibility = "visible"
			progressAfter.current.style.visibility = "visible"
		}
		*/

		let left = offsetX - horizontalOffset

		left = Math.max(0, Math.min(sliderWidth - horizontalOffset * 2, left))

		// update UI immediately (NO cache blocking)
		//console.debug("updateThumbFromTs", moment(targetTs).format(TIME_FORMAT_BACKEND), targetTs, offsetX)
		setThumbInfo(prev => {
			if (prev.thumbIx === targetIx && prev.left === left) return prev
			return { thumbIx: targetIx, left }
		})

		// minimal preload (YouTube-style)
		preloadDirectional(targetIx)
	}

	// =========================================================
	// Thumbnail loading
	// =========================================================

	const loadThumbnailsAround = async (targetTs) => {
		if (loadingRef.current || !effectiveSource) return
		loadingRef.current = true

		const session = hoverSessionRef.current

		try {
			/*
			const start = targetTs ? targetTs - 1800 * 1000 : startTs(effectiveSource.Event)
			const end = targetTs ? targetTs + 1800 * 1000 : endTs(effectiveSource.Event)
			*/
			const start = Math.round(Math.max(targetTs ? targetTs - 1800 * 1000 : startTs(effectiveSource.Event), startTs(effectiveSource.Event)))
			const end = Math.round(Math.min(targetTs ? targetTs + 1800 * 1000 : endTs(effectiveSource.Event), endTs(effectiveSource.Event)))

			//beep()
			//console.trace("loadThumbnailsAround", targetTs, start, moment(start).format(TIME_FORMAT_BACKEND), end, moment(end).format(TIME_FORMAT_BACKEND))
			const around = await effectiveSource.mediaService.getThumbnails(
				channelId(effectiveSource.Event),
				start,
				end
			)
			console.debug("got thumbs", session !== hoverSessionRef.current, around, around?.thumbs?.length,
				start, moment(Math.round(start)).format(TIME_FORMAT_BACKEND),
				end, moment(Math.round(end)).format(TIME_FORMAT_BACKEND),
				targetTs, moment(Math.round(targetTs)).format(TIME_FORMAT_BACKEND))
	
			// stale async result
			if (session !== hoverSessionRef.current) return

			// length is 0 in case of error, keep old thumbs
			if (around?.thumbs?.length > 0) setThumbs(around)
			// 🔥 preload entire window
			//preloadBatch(around)
	
			lastThumbIxRef.current = null

			// recompute after load, prevent displaying thumbnail with index 0 on load
			if (targetTs) {
				updateThumbFromTs(lastTargetTsRef.current, lastOffsetXRef.current)
			}
		}
		finally {
			loadingRef.current = false
		}
	}

	const getVisibleSlider = () => {
		//const slider = document.getElementById("progressSlider")
		const sliders = document.getElementsByClassName("PlayerProgressBar")
		return sliders?.[0]?.checkVisibility({visibilityProperty: true}) ? sliders?.[0] : sliders?.[1]
	}
	
	
	// -----------------------------
	// debounce paging
	// -----------------------------

	const resetThumbsDebounce = () => {
		clearTimeout(loadDebounceRef.current)
		loadDebounceRef.current = null
	}

	const requestThumbsDebounced = (ts) => {
		const timeout = loadDebounceRef.current ? 120 : 0
		resetThumbsDebounce()

		loadDebounceRef.current = setTimeout(() => {
			loadThumbnailsAround(ts)
			resetThumbsDebounce()
		}, timeout)
	}

	// =========================================================
	// Hover logic
	// =========================================================

	const handleMouseMoveInternal = (event) => {
		const thumbsObj = thumbsRef.current
		//console.debug("handleMouseMoveInternal", !progressBar, !thumbsObj?.thumbs?.length, !sliderRect.current, !isHoveringRef.current)
		if (!progressBar || !thumbsObj?.thumbs?.length || !sliderRect.current) return
		if (!isHoveringRef.current) return

		let offsetX = event.offsetX
		//console.debug("handleMouseMoveInternal", offsetX, event?.type, event?.touches)

		if (offsetX === undefined) {
			const touch = event?.touches?.[0]
			const rect = event.target.getBoundingClientRect()
			offsetX = Math.max(0, touch?.clientX - rect?.left)
		}

		const sliderWidth = sliderRect.current.width

		const tsPerPixel =
			(endTs(effectiveSource.GetEvent) - moment(progressBar.eventStartTimeStamp).utc().valueOf()) /
			sliderWidth

		/*
		console.debug("thumbs tsPerPixel", tsPerPixel, sliderWidth,
				moment(progressBar.eventStartTimeStamp).format(TIME_FORMAT_BACKEND), moment(endTs(effectiveSource.GetEvent)).format(TIME_FORMAT_BACKEND),
				effectiveSource, moment(progressBar.eventStartTimeStamp).utc().valueOf(), moment(endTs(effectiveSource.GetEvent)).utc().valueOf(),
				moment(endTs(effectiveSource.GetEvent)).utc().valueOf() - moment(progressBar.eventStartTimeStamp).utc().valueOf())
		*/
		const targetTs = Math.round(offsetX * tsPerPixel + progressBar.eventStartTimeStamp /*- tsPerPixel / 2*/)
		//console.debug("thumbs targetTs", targetTs, moment(targetTs).format(TIME_FORMAT_BACKEND))

		lastTargetTsRef.current = targetTs
		lastOffsetXRef.current = offsetX

		const start = Number(thumbsObj.start)
		const end = Number(thumbsObj.end)
		const evStart = startTs(effectiveSource.Event)
		const evEnd = endTs(effectiveSource.Event)

		//const margin = (end - start) * 0.25
		const margin = 2*60*1000 // 2 min

		// prefetch near edges
		/*
		if (targetTs > end - margin) requestThumbsDebounced(targetTs + margin)
		if (targetTs < start + margin) requestThumbsDebounced(targetTs - margin)
		*/

		//if ((targetTs < moment().utc().valueOf() - liveOffset) && (targetTs < start + margin || targetTs > end - margin)) {
		// limit fetches by considering evStart and evEnd, otherwise fast mouse movements near edges would cause many fetches with invalid targetTs
		if ((targetTs < moment().utc().valueOf() - liveOffset) && ((targetTs < start + margin && evStart < start) || (targetTs > end - margin && evEnd > end))) {
			//console.debug("requestThumbsDebounced bounds", moment(start).format(TIME_FORMAT_BACKEND), moment(evStart).format(TIME_FORMAT_BACKEND), moment(end).format(TIME_FORMAT_BACKEND), moment(evEnd).format(TIME_FORMAT_BACKEND))
			//console.debug("requestThumbsDebounced", targetTs < moment().utc().valueOf() - liveOffset, (targetTs < start + margin || targetTs > end - margin), moment(targetTs).format(TIME_FORMAT_BACKEND), moment(start).format(TIME_FORMAT_BACKEND), moment(end).format(TIME_FORMAT_BACKEND), moment(start + margin).format(TIME_FORMAT_BACKEND), moment(end - margin).format(TIME_FORMAT_BACKEND))
			requestThumbsDebounced(targetTs)
		}

		/*
		if (targetTs < start || targetTs > end) {
			requestThumbsDebounced(targetTs)
			return
		}
		*/

		updateThumbFromTs(targetTs, offsetX)
	}

	const handleMouseLeave = () => {
		// setTimeout to ensure that click event on thumb is registered before hiding
		setTimeout(() => {
			hoverSessionRef.current++

			isHoveringRef.current = false
			setIsHovering(false)

			if (rafRef.current) {
				cancelAnimationFrame(rafRef.current)
				rafRef.current = null
			}

			resetThumbsDebounce()
			setThumbInfo({ thumbIx: null, left: 0 })

			page.setDragOnProgressBar(false)

			// DO NOT fully nuke history
			//lastThumbIxRef.current = null
		}, 200)
	}

	const handleMouseMove = (event) => {
		if (rafRef.current) return

		rafRef.current = requestAnimationFrame(() => {
			rafRef.current = null

			//const slider = document.getElementById("progressSlider")
			const slider = getVisibleSlider()
			if (!slider) {
				// happens when opening volume slider and progress bar is hidden
				//console.error("handleMouseMove NO SLIDER")
				return
			}

			const rect = slider.getBoundingClientRect()
			const x = event.clientX
			const y = event.clientY

			const inside =
				x >= rect.left &&
				x <= rect.right &&
				(page.dragOnProgressBar || y >= rect.top - 40) &&
				// -10 to prevent wrong x position when hovering close to player controls below progress bar
				(page.dragOnProgressBar || y <= rect.bottom - 10)

			//console.debug("thumb inside", inside)
			if (!inside) {
				//console.debug("handleMouseMove NOT INSIDE", rect, x, y, event)
				if (isHoveringRef.current) handleMouseLeave()
				return
			}
			//else console.debug("handleMouseMove INSIDE", rect.top, rect.bottom, x, y, event)

			if (!isHoveringRef.current) {
				isHoveringRef.current = true
				setIsHovering(true)
				// IMPORTANT: re-arm last index so direction + preload works again
				lastThumbIxRef.current = null
			}

			handleMouseMoveInternal(event)
		})
	}

	// =========================================================
	// Layout init
	// =========================================================

	const init = () => {
		const slider = getVisibleSlider()
		if (slider) {
			sliderRect.current = slider?.getBoundingClientRect()
			// textBefore, textAfter
			progressBefore.current = document.getElementById("progressBefore")
			progressBeforeRect.current = progressBefore.current?.getBoundingClientRect()

			progressAfter.current = document.getElementById("progressAfter")
			progressAfterRect.current = progressAfter.current?.getBoundingClientRect()

			bodyInnerRect.current = document.getElementById("body_inner")?.getBoundingClientRect()
			thumbnailContainer.current = document.getElementById("thumbnailContainer")
			vWidth.current = getWindowDimensions()

			const imgBottom = player.isFullScreen && !player.isFullScreenCinema ? vWidth.current < 540 ? 60 :
									60 : player.isFullScreenCinema ? 60 :
									vWidth.current < 540 ? 60 : vWidth.current < 768 ? 60 : 60
			const imgHorizontalOffset =
				vWidth.current < 540 ? (0.5 * 400) / 2 :
				vWidth.current < 768 ? (0.65 * 400) / 2 :
				400 / 2

			const imgWidth =
				vWidth.current < 540 ? 0.5 * 400 :
				vWidth.current < 768 ? 0.65 * 400 :
				400

			const imgHeight =
				vWidth.current < 540 ? 0.5 * 225 :
				vWidth.current < 768 ? 0.65 * 225 :
				225

			thumbstyleRef.current = {
				bottom: imgBottom,
				horizontalOffset: imgHorizontalOffset,
				image: {
					width: imgWidth,
					height: imgHeight,
					display: "block",
					/*
					border: "2px #ffffff solid",
					borderRadius: 11
					*/
				}
			}
		}
	}

	const handleResize = () => {
		// delay for making sure that UI elements are valid
		setTimeout(() => { init() }, 100)
	}

	// =========================================================
	// Effects (ALL above early return)
	// =========================================================

	useEffect(() => {
		if (!shouldRender) return

		init()

		window.addEventListener("pointermove", handleMouseMove)
		// pointerleave is not triggered reliably
		window.addEventListener("pointerup", handleMouseLeave)
		window.addEventListener("pointercancel", handleMouseLeave)
		window.addEventListener("blur", handleMouseLeave)
		window.addEventListener("resize", handleResize)

		loadThumbnailsAround(null)

		return () => {
			window.removeEventListener("pointermove", handleMouseMove)
			window.removeEventListener("pointerup", handleMouseLeave)
			window.removeEventListener("pointercancel", handleMouseLeave)
			window.removeEventListener("blur", handleMouseLeave)
			window.removeEventListener("resize", handleResize)
		}
	}, [shouldRender])

	useEffect(() => {
		if (!shouldRender) return
		handleResize()
	}, [shouldRender, effectivePlayer?.isFullScreenCinema])

	const thumbsObj = thumbsRef.current
	const thumb = thumbsObj?.thumbs?.[thumbInfo.thumbIx]
	const activeHover = isHovering && thumb
	const src = activeHover ? thumbsObj.url + thumb.id : null

	//console.debug("thumb=", thumbsRef.current, thumbInfo, thumbInfo.thumbIx,  Number(thumb?.ts) - (moment().utc().valueOf() - 30000),  Number(thumb?.ts) <= moment().utc().valueOf() - 30000,  Number(thumb?.ts), moment().utc().valueOf() - 30000	, thumb, thumbsObj, thumbInfo, src)

	// Reset loading state when the source changes
	useEffect(() => {
		//console.debug("Image already loaded, setting isLoaded to ", imgRef.current?.complete, src)	
		if (imgRef.current?.complete) setIsLoaded(true)
		else setIsLoaded(false)
	}, [src])

	// =========================================================
	// Safe early return only after all hooks
	// =========================================================

	if (!shouldRender) return null
	
	const CustomValueLabel = memo((props) => {
		const { children, open, value } = props
		//console.debug("CustomValueLabel children %o, open %o, value %o", children, open, value)
		if (!props) return <></>
		//MuiSlider-thumb

		return (
			<Box /*sx={{ position: "relative", display:"inline-block" }}*/ /*position="relative" display="inline-block"*/
			>
				<Tooltip arrow placement={"top"} /*open={open}*/ enterTouchDelay={0} /*interactive="true"*/ title={source?.progressBar["textBefore"] /*value*/}>
					{children}
				</Tooltip>
				<Box sx={{ position: "absolute", top: -170, /*left: 0, px: 1, py: 0.5,*/ width: 240, height: 135, bgcolor: "black", color: "white" }}
				>
					<div style={{ background: "white" }}></div>
				</Box>
			</Box>
		)
	})

	// =========================================================
	// Render
	// =========================================================

	return (
		<div className="PlayerProgressBarWrapper" onClick={(e) => e.stopPropagation()}>
		{/*<div style={{width: "calc(100% - 64px)", height: 58, left: 32, right: 32, position: 'relative'}}>*/}
			{appFeatures.showThumbnails && src && (
				<div
					id="thumbnailContainer"
					style={{
						zIndex: 10,
						bottom: thumbstyleRef.current?.bottom,
						left: thumbInfo.left,
						position: "absolute",
						pointerEvents: "none",
						//backgroundImage: `url(${src}?mode=box&w=400&h=225)`,
						//backgroundColor: '#333', // The "Placeholder" color
						/* UNCOMMENT FOR hourglass placeholder
						backgroundImage: `url(${Hourglass}?mode=box&w=400&h=225)`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						//transition: 'background-image 0.05s linear',
						border: "2px #ffffff solid", borderRadius: 11,
						*/
						overflow: 'hidden'
					}}
				>
					<img
						ref={imgRef}
						loading="eager"
						fetchPriority="high"
						decoding="async"
						//key={thumb?.id} // may cause re-decode + flicker
						//style={thumbstyleRef.current?.image}
						style={{
							...thumbstyleRef.current?.image,
							// Apply dynamic styles based on state
							opacity: isLoaded ? 1 : 0,
							transition: isLoaded ? "none" : "opacity 0.1s ease-in",
							// COMMNENT FOR hourglass placeholder
							border: "2px #ffffff solid", borderRadius: 11,
						}}
						src={src/*+"?mode=box&w=400&h=225"*/}
						//onLoad={(e) => { e.currentTarget.style.opacity = 1 }}
						onLoad={() => setIsLoaded(true)}
					/>
				</div>
			)}

			<div
				id="PlayerProgressBar"
				className={classnames("PlayerProgressBar", {
					PlayerProgressBarFullScreen: effectivePlayer.isFullScreen
				})}
			>
				<Slider
					id="progressSlider"
					className={`${classes.PlayerProgressBarScroll} `}
					{...progressBar.scrollProps}  // {max: 400, min: 0, step: 0.25, value: xx}
					marks={[
						// MTVW-1079: progressValueLiveMarkerValue instead of progressValueLiveMarker
						{ value: progressBar?.progressValueLiveMarkerValue },
						{ value: progressBar?.progressDragMarker, alwaysVisible: true }
					]}
					valueLabelFormat={progressBar?.textBefore}
					/*
					valueLabelFormat={(value) => {
						return (
							<>
								<div>
									{progressBar["textBefore"]}
								</div>
							</>
						)
					}}
					*/
					valueLabelDisplay="auto"
					//slots={{ valueLabel: CustomValueLabel }}
					classes={{
						thumb: `${classes.playerControlSliderThumb} ${classes.playerControlProgressBarSliderThumb}`,
						rail: classes.playerControlProgressBarSliderRail,
						track: classes.playerControlProgressBarSliderTrack,
						mark: classes.playerControlProgressBarLiveMark,
						valueLabel: classes.playerControlSliderLabel
					}}
					sx={{
						/*
						'& .MuiSlider-thumb': {
							width: 24,
							height: 24,
							//boxShadow: 'none',
							'&::after': {
								boxShadow: 'none',       // remove hover "glow"
								width: 24,
								height: 24,
							}
						},
						*/
						"& .MuiSlider-mark": {
							transform: "translate(-10px, -8px) important"
						},
						'& .MuiSlider-mark[data-index="1"]': {
							transform: "translate(-4px, -4px) !important",
							width: 8,
							height: 8,
							background: "white",
							borderRadius: 9999,
							opacity: 1.0,
							// MTVW-1079: uncomment zIndex to put mark above track
							zIndex: "2 !important",
						},
						'& .MuiSlider-track': {
							// uncomment for test
							//zIndex: 1, // put track behind marks
						}
					}}
					onChange={(e, newValue) => {
						//console.debug("Slider onChange", newValue, e?.type, e?.touches)
						onChange(progressBar, newValue, false, thumb?.ts ? Number(thumb.ts) - liveOffset : null)
						controlsTimerHandler(page, true)
					}}
					onChangeCommitted={(e, newValue) => {
						if (progressBefore.current) progressBefore.current.style.visibility = "visible"
						if (progressAfter.current) progressAfter.current.style.visibility = "visible"
						// make sure that tooltip disappears
						if (document.activeElement instanceof HTMLElement) {
							document.activeElement.blur()
						}

						const thumbTs = thumb?.ts ? Number(thumb.ts) - liveOffset : null
						// potential alternative (less reliable?) instead of below handleSetPosition: directly seek to thumb.ts if available, otherwise to newValue
						//onChange(progressBar, newValue, true, thumbTs ?? null)
						/**/
						if (thumbTs && thumbTs < moment().utc().valueOf() - liveOffset) {
							console.debug("seek to", thumbTs, moment(thumbTs).format("YYYY-MM-DD HH:mm:ss"), "ix", thumbInfo.thumbIx)
							effectiveSource.handleSetPosition(moment(thumbTs)).then(() => {
								progressBar?.setPositionDone(true, newValue)
							})
							//controlsTimerHandler(page)
						}
						else {
							onChange(progressBar, newValue, true, null)
						}
						/**/

						controlsTimerHandler(page)
					}}
				/>
			</div>

			<div
				id="progressBefore"
				className={classnames(
					"PlayerProgressBarTextBefore PlayerProgressBarTextAfterResponsive",
					{ [classes.PlayerProgressBarTextAfterFullScreen]: effectivePlayer.isFullScreen }
				)}
				data-test="player_overall_time"
			>
				{effectiveSource?.progressBar?.textAfter === "0:00"
					? "0:00"
					: effectiveSource?.progressBar?.textBefore}
			</div>

			<div
				id="progressAfter"
				className={classnames(
					"PlayerProgressBarTextAfter PlayerProgressBarTextAfterResponsive",
					{ [classes.PlayerProgressBarTextAfterFullScreen]: effectivePlayer.isFullScreen }
				)}
				data-test="player_overall_time"
			>
				{effectiveSource?.progressBar?.textAfter}
			</div>
		</div>
	)
})

//const PlayerLiveIndicator = CreateComponent(null, false, true, ({ state, source, classes, player }) => {
const PlayerLiveIndicator = (props) => {
	const { state, source, classes, player } = props
	// suppress intermedate rendering
	if (!player.isStreamLoaded) return <></>

	// CAUTION: source.isButtonLiveEnabled is reported to be false if SourceContentPlaylist is used for Replay in TvGuide
	
	/*
	const styleNotLive = !state.isFullScreen ? {position: "relative", width: 86, height: 38, marginLeft: 10} :
								{top: 20, position: "relative", width: 106, height: 40, marginLeft: 20}
	*/

	let classLive = !state.isFullScreen ? state.isMedium ? "PlayerControlsLiveMed" : "PlayerControlsLive": "PlayerControlsLiveFS"
	let classIndicator = !state.isFullScreen ? state.isMedium ? "PlayerLiveMedIndicatorContainer": "PlayerLiveIndicatorContainer": "PlayerLiveFsIndicatorContainer"
	if (player.isPaused) {
		classLive = !state.isFullScreen ? state.isMedium ? "PlayerControlsNotLiveMed" : "PlayerControlsNotLive": "PlayerControlsNotLiveFS"
	}
	//console.debug("classIndicator", classIndicator, classLive, source.isButtonLiveEnabled, player.isPaused, player.isStreamLoaded, source)
	const _liveIndicator = (source.type === SourceTypeList.ChannelLive) && (!player.isPaused) ?
		<div className={classes.PlayerControlLiveIndicator}>
			{/* fix safari blur */}
			<img className={classLive} src={LiveIndicator} alt="PlayerLiveOn" data-test="player_live" />
		</div>
		:
		<ButtonCustom state={state} player={player}
			isDisabled={!source.isButtonLiveEnabled && !player.isPaused || source.type === SourceTypeList.ContentPlaylist}
			isLiveIndicator={true}
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				setTimeout(() => {
					source?.setJumpLive()
				}, 10)
			}} data-test="player_live">
			<LightTooltip title={l10n.featureTooltipToLive} isDisabled={!source.isButtonLiveEnabled && !player.isPaused}>
				{/* fix safari blur */}
				<div>
					<img className={classLive} src={NotLive} alt="PlayerLiveOff" data-test="player_not_live" />
				</div>
			</LightTooltip>
		</ButtonCustom>

	return (<div className={classIndicator}>{_liveIndicator}</div>)
}

//const PlayerRecordingIndicator = CreateComponent(null, false, true, ({ state, source, player, managerRecRef, classes }) => {
const PlayerRecordingIndicator = (props) => {
	const { state, source, player, managerRecRef, classes } = props
	
	/*
	useEffect(() => {
		//window.addEventListener("resize", handleResize)
		return (() => {
			//window.removeEventListener("resize", handleResize)
		})
	})
	*/

	//console.debug("PlayerRecordingIndicator", state.classImg)

	const isRecordingActive = () => {
		const marker = rootStore.page.Recordings.Manager.getMarker(eventId(source?.Event))
		if (marker !== null) {
			//console.debug(marker.recType)
			return marker.recType.includes("planned") || marker.recType.includes("complete")
		}
		else return false
	}

	const IsRecorded = rootStore.page.Recordings.Manager.getMarker(eventId(source?.Event))?.isComplete
	// MTV-3062 added for control the recording for series or single episode of series or single episode
	const optionRecording = isSeries(source?.Event) ? [RECORDING_OPTIONS.series_episode_record, RECORDING_OPTIONS.series_record] : [RECORDING_OPTIONS.episode_record]
	return /*state.videoWidth && state.classImg &&*/ (<>
		{(!isRecordingActive()) ?
			<ButtonCustom state={state} player={player} isDisabled={!source.isButtonRecEnabled}
				onClick={(e) => {
					e.stopPropagation();
					if (!isRecordingActive()) void managerRecRef.current.setTypeRecording(optionRecording)
				}}
				// GT12: MTVW-460, MTVW-502: Channels MS flags, !source.isButtonRecHidden
				//data-test="player_rec" >
				data-test="player_rec" style={visibilityHelper(!source.isButtonRecHidden && (IsRecorded === undefined || !IsRecorded)/*, { paddingLeft: 0 }*/)}>
				<LightTooltip title={l10n.featureTooltipRecord} isDisabled={!source.isButtonRecEnabled}>
					<div>
						<img className={state.classImg} style={{scale: 0.9}}src={NotRecording} /*className={`${classes.PlayerControlsRow3Animation}}*/ alt="" />
					</div>
				</LightTooltip>
			</ButtonCustom>
			:
			<div className={!state.isFullScreen ? state.isMedium ? "PlayerControlsRecordingStatusMed" : "PlayerControlsRecordingStatus" :  "PlayerControlsRecordingStatusFs"}>
				{/* <LightTooltip title=IsRecorded ? "Aufnahme abgeschlossen" : "Aufnahme geplant"> */}
				<div>
					<img className={state.classImg} style={{scale: 0.9}} src={IsRecorded ? RecordComplete : RecordPreparing} /*className={`${classes.PlayerControlsRow3Animation}`}*/ alt="" />
				</div>
				{/* </LightTooltip> */}
			</div>
		}
	</>
	)
}

const scrollToMoreEpisodes = () => {
	const episodeCarouselRect = document.getElementById("moreEpisodesCarousel")?.getBoundingClientRect()
	let topElem = document.getElementById("tvLiveAndDetailsContainer")
	let offset = -200
	if (!topElem) {
		topElem = document.getElementsByClassName("MuiDialog-container")?.[0]
		offset = -145
	}
	//console.debug("moreEpisodesCarousel", episodeCarouselRect, topElem, topElem.scrollTop, episodeCarouselRect.top + offset)
	if (topElem && episodeCarouselRect) {
		//https://easings.net/
		const easingOption = "easeInOutExpo"
		Velocity(topElem, { scrollTop: topElem.scrollTop + episodeCarouselRect.top + offset + "px" }, {
			duration: 600,
			easing: easingOption,
			complete: function (val) {
				//if (onComplete) onComplete()
			}
		})
	}
}

// MTV-3583: handle click event for fixing new click away issue introduced with React 17
let subTitleOpen = false
const PlayerControls = CreateComponent(
	null,
	false,
	true,

	forwardRef(({ classes, page, managerRecRef, row3CenterFs }, refWrapperEl) => {
		const [isSubtitle, setSubtitle] = useState(false)

		/* would crash when switching to cinemaMode
		const [state] = useState(() =>
			observable({
				innerWidth: getWindowDimensions(),
				videoWidth: rootStore.page.Player.getVideoElem()?.clientWidth,
				isFullScreen: false,
				isCinemaMode: false,
				isMedium: false,
				classImg: "PlayerControlsImg",
			})
		)
		*/
		/**/
		const [state, setState] = useState({})
		/**/

		const [showVolumeBar, setShowVolumeBar] = useState(false)
		const volumeSliderSelected = useRef(false)
		const anchorSubtitleEl = useRef(null)
		const player = page.player
		const source = page.source
		// player.isMuted does not update the state!
		const isMuted = player.settings._isMuted

		//const [videoDimensions, setVideoDimensions] = useState({})

		const conditionalShowVolumeBar = (show) => {
			if (!page.dragOnProgressBar) {
				setShowVolumeBar(show)
			}
		}

		const handleResize = (videoWidth, videoHeight) => {
			if (!videoWidth) return
			/*
			console.debug("handleResize", page.getVideoElem()?.getBoundingClientRect(), {
				innerWidth: getWindowDimensions(),
				videoWidth: videoWidth,
				isFullScreen: getWindowDimensions() >= 1280 && player.isFullScreen && !player.isFullScreenCinema,
				isCinemaMode: player.isFullScreenCinema,
				isMedium: (videoWidth >= 768 && videoWidth < 960) || getWindowDimensions() < 420,
				classImg: !((getWindowDimensions() >= 1280 && player.isFullScreen && !player.isFullScreenCinema)) ?
					((videoWidth >= 768 && videoWidth < 960) || getWindowDimensions() < 420) ? "PlayerControlsImgMed" : "PlayerControlsImg"
					: "PlayerControlsImgFs"
			})
			*/
			// MTVW-733
			page.adjustPlayerStyles()
			setState({
				innerWidth: getWindowDimensions(),
				videoWidth: videoWidth,
				isFullScreen: getWindowDimensions() >= 1280 && player.isFullScreen && !player.isFullScreenCinema,
				isCinemaMode: player.isFullScreenCinema,
				isMedium: (videoWidth >= 768 && videoWidth < 960) || getWindowDimensions() < 420,
				classImg: !((getWindowDimensions() >= 1280 && player.isFullScreen && !player.isFullScreenCinema)) ?
					((videoWidth >= 768 && videoWidth < 960) || getWindowDimensions() < 420) ? "PlayerControlsImgMed" : "PlayerControlsImg"
					: "PlayerControlsImgFs"
			})
		}

		useEffect(() => {
			setTimeout(() => {
				const videoElem = page.getVideoElem()
				if (videoElem) handleResize(videoElem.clientWidth, videoElem.clientHeight)
			}, 100)
			return (() => {
			})
		}, [])
	
		// make sure that state is updated on isMouseOver
		useEffect(() => {
			const videoElem = page.getVideoElem()
			if (videoElem) handleResize(videoElem.clientWidth, videoElem.clientHeight)	
			// in case elements are not yet ready
			setTimeout(() => {
				const vElem = page.getVideoElem()
				if (vElem) handleResize(vElem.clientWidth, vElem.clientHeight)	
			}, 100)
		}, [page.isMouseOver, player.isFullScreen])

		const size = useResize(page.tvRef, { throttleMs: 20 }, ({ width, height }) => {
			//console.debug("Video resized:", width, height)
			handleResize(width, height)
			//console.debug("PlayerRecordingIndicator useResize", state.classImg)
		})

		if (refWrapperEl.current) {
			refWrapperEl.current.style.visibility = player.isStreamLoaded === false ? "hidden" : "visible"
		}

		const testButtonEnabled = (marker) => {
			return appFeatures.persistedTestButtons &&
				source.hasAdZone(source.type === SourceTypeList.ContentPlaylist ? channelId(source.Event) : source.id, marker)
				|| (marker === source.MARKER_N && appFeatures.persistedNextEpisode && !!source.nextEpisodeInfo?.start)
		}

		return state.videoWidth && (
			<>
				<div
					id={ID_MAIN_CONTROLLER_CONTAINER}
					className={classnames(classes.PlayerControlsMainWrapper, { [classes.PlayerControlsMainWrapperFullScreen]: player.isFullScreen })}
					ref={refWrapperEl}

					// MTV-2504 if click in some "non control" ara in the control bar nothing have to happened
					onClick={e => {
						// MTV-3583: handle click event for fixing new click away issue introduced with React 17
						// if the menu is open the event will be stopped in ClickAwayListener or in player
						if (!subTitleOpen) {
							e.stopPropagation()
						}
						e.preventDefault()
						// if (refWrapperEl.current === e.target) {
						// 	player.setFullScreen(null)
						// }
					}}

					onDoubleClick={e => {
						e.stopPropagation()
						e.preventDefault()
						// if (refWrapperEl.current === e.target) {
						// 	player.setFullScreen(null)
						// }
					}}
				>

					{/* MTV-2133 move in parent */}
					{/* <RecordingsManager ref={managerRef} oEvent={source?.Event} /> */}

					{/* ROW 1 */}

					{player.isFullScreen && <div className={classes.PlayerControlEventFullScreenInfoContainer}>
						<div id="eventTitleFullScreen" className={classes.PlayerControlEventFullScreenInfoTitle} >{title(source?.Event)}</div>
						{isSeries(source?.Event) && <div className={classes.PlayerControlEventFullScreenInfoSubTitle} >
							{season(source?.Event) ? `S${season(source?.Event)}  \u2022 ` : ''}
							{episode(source?.Event) ? `E${episode(source?.Event)}  \u2022 ` : ''}
							{episodeName(source?.Event) ? ` ${episodeName(source?.Event)} ` : ''}</div>}
					</div>}
					<div style={{pointerEvents: page.dragOnProgressBar ? "none" : "auto"}}
						className={classnames(classes.PlayerControlsRow1, { [classes.PlayerControlsRow1FullScreen]: player.isFullScreen })}
					>
						<div id="testButtons" className="PlayerControlsRow1TestButtons">
							<ButtonJumpMarker page={page} state={state} enabled={testButtonEnabled(source.MARKER_B)} icon={JumpB} dataTest={"player_markerB"}
								marker={source.MARKER_B} action={() => source.setJumpMarker(source.MARKER_B)} />
							<ButtonJumpMarker page={page} state={state} enabled={testButtonEnabled(source.MARKER_C)} icon={JumpC} dataTest={"player_markerC"}
								marker={source.MARKER_C} action={() => source.setJumpMarker(source.MARKER_C)} />
							<ButtonJumpMarker page={page} state={state} enabled={testButtonEnabled(source.MARKER_D)} icon={JumpD} dataTest={"player_markerD"}
								marker={source.MARKER_D} action={() => source.setJumpMarker(source.MARKER_D)} />
							<ButtonJumpMarker page={page} state={state} enabled={testButtonEnabled(source.MARKER_N)} icon={JumpN} dataTest={"player_markerN"}
								marker={source.MARKER_N} action={() => source.setJumpMarker(source.MARKER_N)} />
						</div>
					</div>

					{/* ROW 2  */}
					<div className={classnames(classes.PlayerControlsRow2, { [classes.PlayerControlsRow2Fullscreen]: player.isFullScreen })} style={visibilityHelper(!showVolumeBar)}>
						{/* MTV-3384 don't show the progress bar until the event is started */}
						{/* MTV-3474: Remove condition && !player.isLoading */}
						{/* MTVW-444: playerFg */}
						{(page.liveToPausedTransition || player.isStreamLoaded || page.playerFg) && <PlayerProgressBarWrapper page={page} source={page.source} player={player} classes={classes} />}
					</div>

					{/* ROW 3 */}
					<div style={{pointerEvents: page.dragOnProgressBar ? "none" : "auto"}}
						className={classnames(classes.PlayerControlsRow3, { [classes.PlayerControlsRow3Fullscreen]: player.isFullScreen })}
					>
						<div className={classes.PlayerControlsRow3Left}>
							{/* restart */}
							<ButtonCustom state={state} player={player} isDisabled={!source.isButtonReplayEnabled} isHidden={source.isButtonReplayHidden} onClick={(e) => { e.stopPropagation(); void source.setReplay() }} data-test="player_restart">
								<LightTooltip title={l10n.featureTooltipRestart} isDisabled={!source.isButtonReplayEnabled}>
									<div>
										<img className={state.classImg} src={Restart} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							{/* 10 sec back */}
							<ButtonCustom state={state} player={player}
								isDisabled={!source.isButtonJumpRwdEnabled}
								isHidden={source.isButtonJumpRwdHidden}
								onMouseMove={() => {
									controlsTimerHandler(page, true)
								}}
								onMouseLeave={() => {
									controlsTimerHandler(page)
								}}
								onClick={(e) => {
									e.stopPropagation()
									void source.setJumpRwd()
									//MTV-3466 the controls bar doesn't disappear until the user clicks on backward
									controlsTimerHandler(page, true)
									setTimeout(() => { controlsTimerHandler(page) }, 3000)
								}}
								data-test="player_backward10">
								<LightTooltip title={l10n.featureTooltipBackward10} isDisabled={!source.isButtonJumpRwdEnabled}>
									<div>
										<img className={state.classImg} src={Backward10} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							{/* play-pause */}
							<ButtonCustom
								state={state}
								player={player}
								isDisabled={!source.isButtonPlayPauseEnabled}
								isHidden={source.isButtonPlayPauseHidden}
								onClick={(e) => {
									e.stopPropagation()
									e.preventDefault()
									void source.setPlayPause()
									controlsTimerHandler(page, true)
								}}
								data-test="player_play_pause_button"
								data-test-status={`player_is_paused ${player.isPaused}`}
							>
								{/* #TVBDD-468	 */}
								<LightTooltip title={player.isPaused ? l10n.featureTooltipPlay : l10n.featureTooltipPause}
									isDisabled={!source.isButtonPlayPauseEnabled}>
									<div>
										<img className={state.classImg} src={player.isPaused ? Play : Pause} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							{/* 10 second forward */}
							{/*console.debug("isDisabled", !!(source.type === SourceTypeList.ChannelLive || rootStore.page.Player.playerFg), source.type, rootStore.page.Player.playerFg)*/}
							<ButtonCustom state={state} player={player}
								// MTV-3109: enable unless the source is ChannelLive
								//isDisabled={!source.isButtonJumpFwdEnabled}
								// MTVW-444: playerFg
								isDisabled={!!(source.type === SourceTypeList.ChannelLive || rootStore.page.Player?.playerFg)}
								isHidden={source.isButtonJumpFwdHidden}
								onMouseMove={() => {
									controlsTimerHandler(page, true)
								}}
								onMouseLeave={() => {
									controlsTimerHandler(page)
								}}

								onClick={(e) => {
									e.stopPropagation()
									void source.setJumpFwd()
									//MTV-3466 the controls bar doesn't disappear until the user clicks on forward
									controlsTimerHandler(page, true)
									setTimeout(() => { controlsTimerHandler(page) }, 3000)
								}}
								data-test="player_forward10">
								<LightTooltip title={l10n.featureTooltipForward10} isDisabled={source.type === SourceTypeList.ChannelLive || rootStore.page.Player.playerFg}>
									<div>
										<img className={state.classImg} src={Forward10} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							{/* recording indicator */}
							<PlayerRecordingIndicator state={state} source={source} player={player} classes={classes} managerRecRef={managerRecRef} />
							{/* live indicator */}
							<PlayerLiveIndicator state={state} source={source} player={player} classes={classes} />
						</div>

						<div className={classes.PlayerControlsRow3Right}>
							<div className={state.classImg}
								id="PlayerControlsVolume"
								onMouseOver={(e) => { 
									//e.preventDefault()
									e.stopPropagation()
									conditionalShowVolumeBar(true)
								}}
								onFocus={(e) => { 
									//e.preventDefault()
									e.stopPropagation()
									conditionalShowVolumeBar(true)
								}}
								onMouseLeave={(e) => {
									//e.preventDefault()
									e.stopPropagation()
									setTimeout(() => {
										//console.debug("volume= volumeSliderSelected", volumeSliderSelected.current)
										/*if (!volumeSliderSelected.current)*/ setShowVolumeBar(false)
									}, 500)
								}}
								onTouchStart={(e) => {
									//e.preventDefault()
									e.stopPropagation()
									conditionalShowVolumeBar(true)
								}}
							>
								<ButtonCustom state={state} className={classes.PlayerVolumeScrollIcon} player={player}
									isStreamLoaded={true} data-test="player_volume" data-state={`is_muted_${isMuted}`}
									onClick={(e) => {
										e.stopPropagation()
										//e.preventDefault()
										player.setMuteState(!isMuted)
										controlsTimerHandler(page, true)
										// setTimeout(() => { controlsTimerHandler(page) }, 0)
									}}
								>
									<LightTooltip title={isMuted ? l10n.featureTooltipVolumeOn : l10n.featureTooltipVolumeOff} placement="bottom">
										<div>	
											<img className={state.classImg} src={isMuted ? VolumeOff : VolumeOn}
												alt={isMuted ? "volume Off" : "volume On"}
											/>
										</div>
									</LightTooltip>
								</ButtonCustom>

								{/* the volume cannot be set on iOS and iPad */}
								{!(isIpad() || isIphone()) ?
									<div
										className={classes.PlayerVolumeScrollBar}
										style={visibilityHelper(showVolumeBar, 
											{width: player.isFullScreen ? 80 : state.isMedium ? 40 :  "",
											 left: player.isFullScreen && !player.isFullScreenCinema ? 4 :
											 		 player.isFullScreenCinema ? state.isMedium ? -16 : -8 :
													 state.isMedium ? 4 : "",
											 paddingBottom: state.isMedium ? 10 : 10})}
									>
										<Slider aria-label="Volume"
											id='volume-slider'
											classes={{
												thumb: classes.playerControlSliderThumb,
												rail: classes.playerControlVolumeSliderRail,
												track: classes.playerControlVolumeSliderTrack,
											}}
											max={100}
											min={0}
											step={1}
											orientation="vertical"
											value={volumeCheatHelper(player.volume)}
											onChange={(e, newValue) => {
												e.preventDefault()
												player.setVolume(newValue)
												volumeSliderSelected.current = true
												conditionalShowVolumeBar(true)
											}}
											onMouseEnter={(e) => {
												e.preventDefault()
												e.stopPropagation()
												//console.debug("volume= onMouseEnter")
												volumeSliderSelected.current = true
												conditionalShowVolumeBar(true)
											}}
											onMouseLeave={(e) => {
												e.preventDefault()
												e.stopPropagation()
												setTimeout(() => {
													//console.debug("volume= onMouseLeave")
													volumeSliderSelected.current = false
													setShowVolumeBar(false)
												}, 3000)
											}}
										/>
									</div>
									: ""}
							</div>

							{/* MTVW-1081 */}
							{!source.isButtonMoreEpisodesHidden &&
								<ButtonCustom state={state}
									className={classes.PlayerControlSubtitles}
									isDisabled={false}
									player={player}
									data-test="player_moreepisodes"
									onClick={(e) => {
										e.stopPropagation()
										let delay = 0
										if (player.isFullScreen) {
											if (!player.isFullScreenCinema) {
												page.player.setFullScreen(null).then(() => {
													source.setFullScreen(false)
												})
											}
											else source.setFullScreen(null, true)
											// delay for valid DOM elements
											delay = 500
										}
										setTimeout(() => {
											scrollToMoreEpisodes()
										}, delay)
									}}
								>
									<LightTooltip title={l10n.featureTooltipMoreEpisodes} isDisabled={!source.isButtonTrackAudioEnabled && !source.isButtonTrackSubtitleEnabled}>
										<div>
											<img className={state.classImg} src={MoreEpisodes} style={{scale: 0.5}} alt="" />
										</div>
									</LightTooltip>
								</ButtonCustom>
							}

							<ButtonCustom state={state}
								className={classes.PlayerControlSubtitles}
								isDisabled={!source.isButtonTrackAudioEnabled && !source.isButtonTrackSubtitleEnabled}
								player={player}
								data-test="player_subtitles"
								ref={anchorSubtitleEl}
								onClick={(e) => {
									e.stopPropagation();
									void setSubtitle(!isSubtitle)
									// MTV-3583: handle click event for fixing new click away issue introduced with React 17
									subTitleOpen = !isSubtitle
								}}
							>
								<LightTooltip title={l10n.featureTooltipSubtitles} isDisabled={!source.isButtonTrackAudioEnabled && !source.isButtonTrackSubtitleEnabled}>
									<div>
										<img className={state.classImg} src={Subtitles} style={{scale: 0.8}} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							<Popper
								open={page.isControlsVisible && isSubtitle ? true : false}
								anchorEl={() => anchorSubtitleEl.current}
								placement="top"
								modifiers={[
									{
										name: "offset",
										options: {
											offset: [0, 50],
										},
									},
								]}
								//sx={{position: "relative", bottom: 300, right: 300}}
								disablePortal={true}
								className={classes.PlayerControlSubtitlesPopper}
								onClick={(e) => {
									e.stopPropagation()
									// MTV-3583: handle click event for fixing new click away issue introduced with React 17
									// not necessary in responsive
									e.preventDefault()
									void setSubtitle(false)
									setTimeout(() => { subTitleOpen = false }, 500)
								}}
							>
								<ClickAwayListener onClickAway={(e) => {
									e.stopPropagation()
									e.preventDefault()
									// MTV-3583: handle click event for fixing new click away issue introduced with React 17
									// could be fixed in a future update, so this workaround could be eliminated.
									void setSubtitle(false)
									setTimeout(() => { subTitleOpen = false }, 500)
								}}>
									<PlayerControlAudioSubtitlesMenu page={page} player={player} setSubtitle={setSubtitle} classes={classes} isInPlayerControlsResponsive={false} />
								</ClickAwayListener>
							</Popper>

							{/* MTVW-727 */}
							{page.isPiPButtonEnabled && <ButtonCustom
								state={state}
								data-test="player_pip"
								player={player}
								isDisabled={false}
								isHidden={false}
								onClick={(e) => {
									e.stopPropagation();
									if (page.isControlsVisible) page.setMouseOver(false)
									source.showPiP(true)
								}}
							>
								<LightTooltip title={l10n.featureTooltipPip}>
									<div>
										<img className={state.classImg} src={PictureInPicture} alt="PIP enter" />
									</div>
								</LightTooltip>
							</ButtonCustom>}

							{!isPhoneSize() && !isAndroid() && !isIpad() /*&& page.isPlayerOnOverlay*/ &&
								<>
									<ButtonCustom
										state={state}
										className={classes.PlayerControlsFullscreen}
										data-test="player_cinemamode"
										player={player}
										isDisabled={!source.isButtonFullScreenEnabled}
										isHidden={source.isButtonFullScreenHidden}
										onClick={(e) => {
											e.stopPropagation()
											// MTVW-452: hide the controls if change to full screen and if is iPhone
											if (page.isControlsVisible && isIphone()) page.setMouseOver(false)
											if (player.isFullScreen && !player.isFullScreenCinema) {
												source.setFullScreen(false).then(() => {
													source.setFullScreen(null, true)
												})
											}
											else source.setFullScreen(null, true)
										}}
									>
										<LightTooltip title={player.isFullScreenCinema ? l10n.featureTooltipCinemamodeOff : l10n.featureTooltipCinemamodeOn} isDisabled={!source.isButtonFullScreenEnabled}>
											<div>
												<img className={state.classImg} src={!player.isFullScreenCinema ? CinemaModeEnable : CinemaModeDisable}
													alt={!player.isFullScreenCinema ? "cinemamode enter" : "cinema mode exit"} />
											</div>
										</LightTooltip>
									</ButtonCustom>
								</>
							}

							<ButtonCustom
								state={state}
								className={classes.PlayerControlsFullscreen}
								data-test="player_fullscreen"
								player={player}
								isDisabled={!source.isButtonFullScreenEnabled}
								isHidden={source.isButtonFullScreenHidden}
								onClick={(e) => {
									e.stopPropagation()
									// MTVW-452: hide the controls if change to full screen and if is iPhone
									if (page.isControlsVisible && isIphone()) page.setMouseOver(false)
									source.setFullScreen(null)
								}}
							>
								<LightTooltip title={player.settings.isFullScreen ? l10n.featureTooltipFullscreenOff : l10n.featureTooltipFullscreenOn} isDisabled={!source.isButtonFullScreenEnabled}>
								<div>
									<img className={state.classImg} src={player.settings.isFullScreen ? FullscreenExit : FullscreenEnter}
										alt={player.settings.isFullScreen ? "fullscreen exit" : "fullscreen enter"} />
									</div>
								</LightTooltip>
							</ButtonCustom>
						</div>
					</div>
				</div>
			</>
		)
	})
)

const PlayerControlsResponsive = CreateComponent(
	null,
	false,
	true,

	forwardRef(({ classes, page, managerRecRef }, refWrapperEl) => {
		/* would crash when switching to cinemaMode
		const [state] = useState(() =>
			observable({
			innerWidth: getWindowDimensions(),
			videoWidth: page.getVideoElem()?.clientWidth,
			isFullScreen: false,
			isCinemaMode: false,
			isMedium: false,
			classImg: "PlayerControlsImg",
			})
		)
		*/
		const [state, setState] = useState({})

		const [isSubtitle, setSubtitle] = useState(false)
		const anchorSubtitleEl = useRef(null)
		const player = page.player
		const source = page.source
		// player.isMuted does not update the state!
		const isMuted = player.settings._isMuted
		
		//const [videoDimensions, setVideoDimensions] = useState({})

		const handleResize = (videoWidth, videoHeight) => {
			if (!videoWidth) return
			//setVideoDimensions({ videoWidth, videoHeight })
			// MTVW-733
			page.adjustPlayerStyles()
			/*
			console.debug("handleResize responsive", page.getVideoElem()?.getBoundingClientRect(), {
				innerWidth: getWindowDimensions(),
				videoWidth: videoWidth,
				isFullScreen: getWindowDimensions() >= 1280 && player.isFullScreen && !player.isFullScreenCinema,
				isCinemaMode: player.isFullScreenCinema,
				isMedium: (videoWidth >= 768 && videoWidth < 960) || getWindowDimensions() < 420,
				classImg: !((getWindowDimensions() >= 1280 && player.isFullScreen && !player.isFullScreenCinema)) ?
					((videoWidth >= 768 && videoWidth < 960) || getWindowDimensions() < 420) ? "PlayerControlsImgMed" : "PlayerControlsImg"
					: "PlayerControlsImgFs"
			})
			*/
			setState({
				innerWidth: getWindowDimensions(),
				videoWidth: videoWidth,
				isFullScreen: getWindowDimensions() >= 1280 && player.isFullScreen && !player.isFullScreenCinema,
				isCinemaMode: player.isFullScreenCinema,
				isMedium: (videoWidth >= 768 && videoWidth < 960) || getWindowDimensions() < 420,
				classImg: !((getWindowDimensions() >= 1280 && player.isFullScreen && !player.isFullScreenCinema)) ?
					((videoWidth >= 768 && videoWidth < 960) || getWindowDimensions() < 420) ? "PlayerControlsImgMed" : "PlayerControlsImg"
					: "PlayerControlsImgFs"
			})
		}

		useEffect(() => {
			setTimeout(() => {
				const videoElem = page.getVideoElem()
				if (videoElem) handleResize(videoElem.clientWidth, videoElem.clientHeight)
			}, 100)
			//window.addEventListener("resize", handleResize)
			return (() => {
				//window.removeEventListener("resize", handleResize)
			})
		}, [])

		// make sure that state is updated on isMouseOver
		useEffect(() => {
			const videoElem = page.getVideoElem()
			if (videoElem) handleResize(videoElem.clientWidth, videoElem.clientHeight)
			// in case elements are not yet ready
			setTimeout(() => {
				const vElem = page.getVideoElem()
				if (vElem) handleResize(vElem.clientWidth, vElem.clientHeight)
			}, 100)
		}, [page.isMouseOver, player.isFullScreen])

		// Trying to set state for opened audio subtiles on mobile
		// let [AudioOpened, setAudioOpened] = useState(false);
		// const _handleChangeAudioOpened = () => {
		// 	return setAudioOpened(!AudioOpened)
		// }

		// const handleChangeAudioOpened = _handleChangeAudioOpened.bind(this)

		const size = useResize(window, { throttleMs: 20 }, ({ width, height }) => {
			//console.debug("Video resized:", width, height)
			handleResize(width, height)
		})

		if (refWrapperEl.current) {
			refWrapperEl.current.style.visibility = player.isStreamLoaded === false ? "hidden" : "visible"
		}

		const testButtonEnabled = (marker) => {
			if (marker === source.MARKER_N) {
				return appFeatures.persistedNextEpisode && appFeatures.persistedTestButtons && source.nextEpisodeInfo?.start
			}
			else return appFeatures.persistedTestButtons &&
				source.hasAdZone(source.type === SourceTypeList.ContentPlaylist ? channelId(source.Event) : source.id, marker)
		}

		return state.videoWidth && (
			<div
				id={ID_MAIN_CONTROLLER_CONTAINER}
				// MTVW-452
				//className={classnames(classes.PlayerControlsMainWrapper, { [classes.PlayerControlsMainWrapperFullScreen]: player.isFullScreen })}
				className={classnames(classes.PlayerControlsMainWrapper, { [classes.PlayerControlsMainWrapperFullScreenResponsive]: player.isFullScreen })}
				ref={refWrapperEl}
				// MTV-2504 if click in some "non control" ara in the control bar nothing have to happened
				onClick={e => {
					// MTV-3583: handle click event for fixing new click away issue introduced with React 17
					if (!subTitleOpen) {
						e.stopPropagation()
					}
					if (page.isControlsVisible) page.setMouseOver(false)
					// e.stopPropagation()
					e.preventDefault()
					// if (refWrapperEl.current === e.target) {
					// 	player.setFullScreen(null)
					// }
				}}
				onDoubleClick={e => {
					e.preventDefault()
					e.stopPropagation()

					// if (refWrapperEl.current === e.target) {
					// 	player.setFullScreen(null)
					// }
				}}
				style={state.innerWidth < 1440 ? {
					display: "flex", flexDirection: "column", background: "rgba(0,0,0,.6)", zIndex: 1
				} : { display: "flex", flexDirection: "column", zIndex: 1 }}
			>

				{/* MTV-2133 move in parent */}
				{/* <RecordingsManager ref={managerRef} oEvent={source?.Event} /> */}

				<div style={{pointerEvents: page.dragOnProgressBar ? "none" : "auto"}}
					className={classes.PlayerControlsRow1Responsive} id={`${ID_PLAYER_CONTROLLER_RESPONSIVE}_row1`}
				>

					{/* MTVW-509 */}
					{/* <div className={classnames(classes.PlayerControlsRow1Responsive, { [classes.PlayerControlsRow1FullScreen]: player.isFullScreen })}> */}

					{/* ROW 1 */}

					<div className={classes.PlayerControlsRow1LeftResponsive}>
						{player.isFullScreen && <div className={classes.PlayerControlEventFullScreenInfoContainerResponsive}>
							<div id="eventTitleFullScreen" className={classes.PlayerControlEventFullScreenInfoTitle} >{title(source?.Event)}</div>
							{isSeries(source?.Event) && <div className={classes.PlayerControlEventFullScreenInfoSubTitle} >
								{season(source?.Event) ? `S${season(source?.Event)}  \u2022 ` : ''}
								{episode(source?.Event) ? `E${episode(source?.Event)}  \u2022 ` : ''}
								{episodeName(source?.Event) ? ` ${episodeName(source?.Event)} ` : ''}</div>}
						</div>}
						
						<Popper
							open={page.isControlsVisible && isSubtitle ? true : false}
							anchorEl={() => anchorSubtitleEl.current}
							placement="bottom-start"
							// MTV-2575: diablePortal must be true, otherwise the subtitles menu will not be displayed in fullscreen!
							disablePortal={true}
							className={"PlayerControlSubtitlesPopperResponsive"}
						>
							<ClickAwayListener onClickAway={(e) => {
								e.stopPropagation()
								e.preventDefault()
								void setSubtitle(false)
								// MTV-3583: handle click event for fixing new click away issue introduced with React 17
								// could be fixed in a future update, so this workaround could be eliminated.
								// if the menu is open the event will be stoped in ClickAwayListener or in player
								setTimeout(() => { subTitleOpen = false }, 500)
							}}>
								<PlayerControlAudioSubtitlesMenu page={page} player={player} setSubtitle={setSubtitle} classes={classes} isInPlayerControlsResponsive={true} />

							</ClickAwayListener>
						</Popper>
						{!isSubtitle && (
							<ButtonCustom state={state} className={classes.PlayerVolumeScrollIconResponsive} player={player}
								isStreamLoaded={true} data-test="player_volume" data-state={`is_muted_${isMuted}`}
								onClick={(e) => {
									e.stopPropagation()
									//e.preventDefault()
									player.setMuteState(!isMuted)
									controlsTimerHandler(page, true)
									// setTimeout(() => { controlsTimerHandler(page) }, 0)
								}}
							>
								<LightTooltip title={isMuted ? l10n.featureTooltipVolumeOn : l10n.featureTooltipVolumeOff} placement="bottom">
									<div>
										<img className={state.classImg} src={isMuted ? VolumeOff : VolumeOn}
											alt={isMuted ? "volume Off" : "volume On"}
										/>
									</div>
								</LightTooltip>
							</ButtonCustom>
						)}
						<ButtonCustom
							state={state}
							className={classes.PlayerControlSubtitlesResponsive}
							isDisabled={!source.isButtonTrackAudioEnabled && !source.isButtonTrackSubtitleEnabled}
							player={player}
							data-test="player_subtitles"
							ref={anchorSubtitleEl}
							onClick={(e) => {
								e.stopPropagation();
								setSubtitle(!isSubtitle)
								// MTV-3583: handle click event for fixing new click away issue introduced with React 17
								subTitleOpen = !isSubtitle
							}}
						>
							{!isSubtitle &&
								<LightTooltip title={l10n.featureTooltipSubtitles} isDisabled={!source.isButtonTrackAudioEnabled && !source.isButtonTrackSubtitleEnabled}>
									<div>
										{!isSubtitle && <img className={state.classImg} src={Subtitles} style={{scale: 0.8}} alt="" />}
									</div>
								</LightTooltip>
							}

						</ButtonCustom>

						{!isSubtitle && <> <PlayerRecordingIndicator state={state} source={source} player={player} classes={classes} managerRecRef={managerRecRef} />
						</>}
					</div>	

					<div className={classes.PlayerControlsRow1RightResponsive}
					style={{right: page.isPlayerOnOverlay && !player.isFullScreen? 56 : ""}}>

						{/* MTVW-1081 */}
						{!source.isButtonMoreEpisodesHidden &&
							<ButtonCustom state={state}
								className={classes.PlayerControlSubtitles}
								isDisabled={false}
								player={player}
								data-test="player_moreepisodes"
								onClick={(e) => {
									e.stopPropagation()
									let delay = 0
										if (player.isFullScreen) {
											if (!player.isFullScreenCinema) {
												page.player.setFullScreen(null).then(() => {
													source.setFullScreen(false)
												})
											}
											else source.setFullScreen(null, true)
											// delay for valid DOM elements
											delay = 500
										}
										setTimeout(() => {
											scrollToMoreEpisodes()
										}, delay)
								}}
							>
								<LightTooltip title={l10n.featureTooltipMoreEpisodes} isDisabled={!source.isButtonTrackAudioEnabled && !source.isButtonTrackSubtitleEnabled}>
									<div>
										<img className={state.classImg} src={MoreEpisodes} style={{scale: 0.5}} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							}

						{/* MTVW-727 */}
						{!isSubtitle && page.isPiPButtonEnabled && <ButtonCustom
							state={state}
							data-test="player_pip"
							player={player}
							isDisabled={false}
							isHidden={false}
							onClick={(e) => {
								e.stopPropagation();
								if (page.isControlsVisible) page.setMouseOver(false)
								source.showPiP(true)
							}}
						>
							<LightTooltip title={l10n.featureTooltipPip}>
								<div>
									<img className={state.classImg} src={PictureInPicture} alt="PIP enter" />
								</div>
							</LightTooltip>
						</ButtonCustom>}

						{!isPhoneSize() && !isAndroid() && !isIpad() /*&& page.isPlayerOnOverlay*/ &&
							<>
								<ButtonCustom
									state={state}
									className={classes.PlayerControlsFullscreen}
									data-test="player_cinemamode"
									player={player}
									isDisabled={!source.isButtonFullScreenEnabled}
									isHidden={source.isButtonFullScreenHidden}
									onClick={(e) => {
										e.stopPropagation();
										// MTVW-452: hide the controls if change to full screen and if is iPhone
										if (page.isControlsVisible && isIphone()) page.setMouseOver(false)
										if (player.isFullScreen && !player.isFullScreenCinema) {
											source.setFullScreen(false).then(() => {
												source.setFullScreen(null, true)
											})
										}
										else source.setFullScreen(null, true)
									}}
								>
									{!isSubtitle &&
										<LightTooltip title={player.isFullScreenCinema ? l10n.featureTooltipCinemamodeOff : l10n.featureTooltipCinemamodeOn} isDisabled={!source.isButtonFullScreenEnabled}>
											<div>
												<img className={state.classImg} src={!player.isFullScreenCinema ? CinemaModeEnable : CinemaModeDisable}
													alt={!player.isFullScreenCinema ? "cinemamode enter" : "cinema mode exit"} />
											</div>
										</LightTooltip>
									}
								</ButtonCustom>
							</>
						}

						{!isSubtitle && <ButtonCustom
							state={state}
							className={classes.PlayerControlsFullscreen}
							data-test="player_fullscreen"
							player={player}
							isDisabled={!source.isButtonFullScreenEnabled}
							isHidden={source.isButtonFullScreenHidden}
							// MTVW-452: added style
							//style={player.isFullScreen ? { bottom: "13px" } : { bottom: "23px" }}
							onClick={(e) => {
								e.stopPropagation()
								// MTVW-452: hide the controls if change to full screen and if is iPhone
								if (page.isControlsVisible && isIphone()) page.setMouseOver(false)
								source.setFullScreen(null)
							}}
						>
							<LightTooltip title={player.settings.isFullScreen ? l10n.featureTooltipFullscreenOff : l10n.featureTooltipFullscreenOn} isDisabled={!source.isButtonFullScreenEnabled}>
								<div>
									<img className={state.classImg} src={player.settings.isFullScreen ? FullscreenExit : FullscreenEnter}
										alt={player.settings.isFullScreen ? "fullscreen exit" : "fullscreen enter"} />
								</div>
							</LightTooltip>
						</ButtonCustom>}
					</div>
				</div>

				{/* ROW 2 */}
				{!isSubtitle &&
					<div style={{pointerEvents: page.dragOnProgressBar ? "none" : "auto"}}
						className="PlayerControlsRow2Responsive"
					>
						{/* MTVW-754:  justifyContent: "center" when using PlayerControlsRow3Center*/}
						<div className={classnames(classes.PlayerControlsRow3Center, { [classes.PlayerControlsRow3CenterFullScreen]: player.isFullScreen })} style={{ justifyContent: "center" }}>
							{/* restart */}
							<ButtonCustom state={state} player={player} isDisabled={!source.isButtonReplayEnabled} isHidden={source.isButtonReplayHidden} onClick={(e) => { e.stopPropagation(); void source.setReplay() }} data-test="player_restart">
								<LightTooltip title={l10n.featureTooltipRestart} isDisabled={!source.isButtonReplayEnabled}>
									<div>
										<img className={state.classImg} src={Restart} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							{/* 10 sec back */}
							<ButtonCustom state={state} player={player}
								isDisabled={!source.isButtonJumpRwdEnabled}
								isHidden={source.isButtonJumpRwdHidden}
								onMouseMove={() => {
									controlsTimerHandler(page, true)
								}}
								onMouseLeave={() => {
									controlsTimerHandler(page)
								}}
								onClick={(e) => {
									e.stopPropagation()
									void source.setJumpRwd()
									//MTV-3466 the controls bar doesn't disappear until the user clicks on backward
									controlsTimerHandler(page, true)
									setTimeout(() => { controlsTimerHandler(page) }, 3000)
								}}
								data-test="player_backward10">
								<LightTooltip title={l10n.featureTooltipBackward10} isDisabled={!source.isButtonJumpRwdEnabled}>
									<div>
										<img className={state.classImg} src={Backward10} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							{/* play pause  */}
							<ButtonCustom
								state={state}
								player={player}
								isDisabled={!source.isButtonPlayPauseEnabled}
								isHidden={source.isButtonPlayPauseHidden}
								onClick={(e) => {
									e.stopPropagation()
									e.preventDefault()
									void source.setPlayPause()
									controlsTimerHandler(page, true)
									// setTimeout(() => { controlsTimerHandler(page) }, 0)
								}}
								data-test="player_play_pause_button"
								data-test-status={`player_is_paused ${player.isPaused}`}
							>
								<LightTooltip title={player.isPaused ? l10n.featureTooltipPlay : l10n.featureTooltipPause}
									isDisabled={!source.isButtonPlayPauseEnabled}>
									<div>
										<img className={state.classImg} src={player.isPaused ? Play : Pause} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>

							{/* 10 sec forward	 */}
							<ButtonCustom state={state} player={player}
								//MTV-3109 // still enable until is the event is Live
								//isDisabled={!source.isButtonJumpFwdEnabled}
								isDisabled={source.type === SourceTypeList.ChannelLive}
								isHidden={source.isButtonJumpFwdHidden}
								onMouseMove={() => {
									controlsTimerHandler(page, true)
								}}
								onMouseLeave={() => {
									controlsTimerHandler(page)
								}}
								onClick={(e) => {
									e.stopPropagation()
									void source.setJumpFwd()
									//MTV-3466 the controls bar doesn't disappear until the user clicks on forward
									controlsTimerHandler(page, true)
									setTimeout(() => { controlsTimerHandler(page) }, 3000)
								}}
								data-test="player_forward10">
								<LightTooltip title={l10n.featureTooltipForward10} isDisabled={source.type === SourceTypeList.ChannelLive}>
									<div>
										<img className={state.classImg} src={Forward10} alt="" />
									</div>
								</LightTooltip>
							</ButtonCustom>
							{/* live indicator */}
							<PlayerLiveIndicator state={state} source={source} player={player} classes={classes} />
						</div>
					</div>
				}

				{/* ROW 3  */}
				{!isSubtitle &&
					<div style={{pointerEvents: page.dragOnProgressBar ? "none" : "auto"}}
						className="PlayerControlsRow3Responsive" id={`${ID_PLAYER_CONTROLLER_RESPONSIVE}_row3`}
					>
						<div id="testButtons" className="PlayerControlsRow3TestButtons" >
							<ButtonJumpMarker page={page} state={state} enabled={testButtonEnabled(source.MARKER_B)} icon={JumpB} dataTest={"player_markerB"}
								marker={source.MARKER_B} action={() => source.setJumpMarker(source.MARKER_B)} />
							<ButtonJumpMarker page={page} state={state} enabled={testButtonEnabled(source.MARKER_C)} icon={JumpC} dataTest={"player_markerC"}
								marker={source.MARKER_C} action={() => source.setJumpMarker(source.MARKER_C)} />
							<ButtonJumpMarker page={page} state={state} enabled={testButtonEnabled(source.MARKER_D)} icon={JumpD} dataTest={"player_markerD"}
								marker={source.MARKER_D} action={() => source.setJumpMarker(source.MARKER_D)} />
							<ButtonJumpMarker page={page} state={state} enabled={testButtonEnabled(source.MARKER_N)} icon={JumpN} dataTest={"player_markerN"}
								marker={source.MARKER_N} action={() => source.setJumpMarker(source.MARKER_N)} />
						</div>
						{/*
						<div className={classnames(classes.PlayerControlsRow2, { [classes.PlayerControlsRow2Fullscreen]: player.isFullScreen })}>
							<div className={classes.PlayerControlsRow3Left}>
								{player.isStreamLoaded && <PlayerProgressBarWrapper source={page.source} player={player} classes={classes} />}
							</div>
						</div>
						*/}
						{/* MTVW-466: added div*/}
						<div id={`${ID_PLAYER_CONTROLLER_RESPONSIVE}_row2`} className={classnames(classes.PlayerControlsRow2, { [classes.PlayerControlsRow2Fullscreen]: player.isFullScreen })}>
							{/* MTV-3384 don't show progress bar until the event is loaded  */}
							{/* MTV-3474: Remove condition && !player.isLoading */}
							{/* MTVW-444: playerFg */}
							{(player.isStreamLoaded || page.playerFg) && <PlayerProgressBarWrapper page={page} source={page.source} player={player} classes={classes} />}
						</div>
					</div>
				}
			</div>
		)
	})
)

const PlayerLoading = CreateComponent(null, false, true, ({ classes, player }) => (
	<>
		{/* MTV-3427 Safari return a callback later and the spinner was visible behind the error message
			added rootStore.page?.Player?.error to not show the spinner on safari in case of error*/}
		{(player.isLoading && !rootStore.page?.Player?.error) && (
			<div className={classes.PlayerLoadingWrapper}>
				<CircularProgress size={100} data-test="player_loading" />
			</div>
		)}
	</>
))

const PlayerMutedByBrowser = CreateComponent(null, false, true, ({ classes, page }) => (
	<div
		className={classes.PlayerMutedByBrowserWrapper}
		onClick={(e) => {
			e.stopPropagation()
			void page.player.setMutedByBrowser(false)
			void page.setMouseOver(true)
		}}
	>
		{page.isControlsVisible && (<VolumeOffBrowser className={classes.PlayerMutedByBrowserIcon} sx={{ fontSize: "120px" }} data-test="player_browser_muted" />)}
	</div>
))

// MTVW-452:
// Adjust the screen size for phones
const resizePhonePlayerVideo = (page) => {
	return
	// the values of window.screen.availWidth and window.screen.availHeight depend on how the application is opened, whether in Portrait or Landscape.
	// they never change even if the phone is rotated
	// in landscape the height is the lowest value

	const activePlayer = page.source.adState?.fastFwd || page.source.adState?.replay ? page.player.domElementId.ADS_PLAYER : page.player.domElementId.TV_PLAYER
	const playerElement = document.getElementById(activePlayer)

	if (!playerElement) return
	// MTVW-733: Test, exclude Android
	//if ((isPhoneSize()) || isAndroid()) {
	if (isIphone()) {
		if (page.player.isFullScreen && window.innerHeight < window.innerWidth) {
			// landscape
			playerElement.style.width = "100vw" //"95vw" //isAndroid() ? "90vw" : "95vw"
		} else {
			playerElement.style.width = "100%"
		}
	}

	// For iPhone: fix the issue of cut video in case the landscape tab bar is visible
	if (isIphone()) {
		const availHeight = Math.min(window.screen.availWidth, window.screen.availHeight)

		playerElement.style.margin = "unset"
		if ((page.player.settings.isFullScreen) && (availHeight > window.innerHeight) && (window.innerHeight < window.innerWidth)) {
			// calculation of the width with the new height:
			// innerWidth: availHeight = x: innerHeight
			const newWidth = window.innerWidth * window.innerHeight / availHeight
			playerElement.style.width = `${newWidth * 90 / 100}px`
			playerElement.style.margin = "auto"
		}
	}
}

const PlayerControlsWrapper = CreateComponent(null, false, true, ({ classes, page, managerRecRef }) => {
	const wrapperRef = useRef(null)
	// const managerRecRef = useRef() MTV-3398  Moved out of PlayerControlsWrapper
	const [videoWidth, setVideoWidth] = useState(null)

	//MTVW-452
	const handleOrientationChange = (event) => {
		if (event !== null) {
			event.stopPropagation();
			event.preventDefault();
		}
		// MTVW-733: Test with page.setMouseOver(false)
		// screen.orientation.type not available on Edge/iOS and iPadOS
		//console.debug("handleOrientationChange type %o, sInfo %o, event %o", screen?.orientation?.type, screenInfo(), event?.target)
		page.player?.__parent?.orientationChange(event)
		page.setMouseOver(false)

		//page.adjustPlayerStyles()
		setTimeout(() => {// need delay for updating window
			handleResize()
		}, 100)
	}

	const handleResize = () => {
		//console.debug("handleResize PlayerControlsWrapper")
		// MTVW-452
		resizePhonePlayerVideo(page)

		//setWindowDimensions(getWindowDimensions())
		// MTV-3523
		// added setTimeout for synchronization of the updated video's clientWidth
		// see links:
		// https://stackoverflow.com/questions/9083594/call-settimeout-without-delay
		// https://medium.com/@Rahulx1/understanding-event-loop-call-stack-event-job-queue-in-javascript-63dcd2c71ecd
		//setTimeout(() => {
		const video = page.getVideoElem()
		if (video) {
			// MTVW-733: Use page.calcVideoDimensions
			//setVideoWidth(video.clientWidth)
			//console.debug("handleResize sInfo", screenInfo())
			// MTVW-826: cinemamode use this.player.isFullScreen
			//const vDimensions = page.calcVideoDimensions(page.player.settings.isFullScreen)
			const vDimensions = page.calcVideoDimensions(page.player.isFullScreen)
			//console.debug("handleResize calcVideoDimensions", vDimensions)
			const nextWidth = vDimensions.width
			setVideoWidth(prev => {
			  if (prev === nextWidth) return prev
			  return nextWidth
			})
			//console.debug("wrapper handleResize adjustPlayerStyles, fs %o, vW %o, hH %o", page.player.settings.isFullScreen, video.clientWidth, video.clientHeight)
			// MTVW-733
			page.adjustPlayerStyles()
			//console.debug("video with %s", video.clientWidth)
		}
		//})
	}

	/*
	useEffect(
		...page.getMountBody(
			() => {
				// MTVW-452: added addEventListener for "orientationchange"
				// crashes on Edge/iPad
				//screen.orientation.addEventListener("change", handleOrientationChange)
				// actually deprecated
				window.addEventListener("orientationchange", handleOrientationChange)
				window.addEventListener("resize", handleResize)
				handleResize()
			},
			() => {
				//screen.orientation.removeEventListener("change", handleOrientationChange)
				window.removeEventListener("orientationchange", handleOrientationChange)
				window.removeEventListener("resize", handleResize)
			}
		)
	)
	*/

	useEffect(() => {
		// MTVW-452: added addEventListener for "orientationchange"
		// crashes on Edge/iPad
		//screen.orientation.addEventListener("change", handleOrientationChange)
		// actually deprecated
		window.addEventListener("orientationchange", handleOrientationChange)
		window.addEventListener("resize", handleResize)
		handleResize()
		return (() => {
			//screen.orientation.removeEventListener("change", handleOrientationChange)
			window.removeEventListener("orientationchange", handleOrientationChange)
			window.removeEventListener("resize", handleResize)
		})
	}, [])

	useEffect(() => {
		handleResize()
	}, [page.player.isStreamLoaded])

	useLayoutEffect(() => {
		handleResize()
		//console.debug("useLayoutEffect")
	}/*, [page.player.isFullScreen]*/)

	// MTVW-452:
	// needed to rerender the component also for AdsPlayer to force the call of handleResize
	useEffect(() => {
		// allow keeping the controls of the player inside the player e.g. full-screen portrait mobile
		//console.debug("useEffect adjustPlayerStyles fs=", page.player.settings.isFullScreen)
		page.adjustPlayerStyles()
		// eslint-disable-next-line react-hooks/exhaustive-deps
		// MTVW-826: cinemamode use this.player.isFullScreen
	}, [/*page.player.settings.isFullScreen*/ page.player.isFullScreen])

	if (page.player.isMutedByBrowser === true) {
		// MTV-2525: don't hide mute icon
		controlsTimerHandler(page, true)
		return <PlayerMutedByBrowser classes={classes} page={page} />
	}

	return videoWidth && (
		<div id="playerControls"
			// CAUTION: Applying a change to below breakpoint value requires also the same change in global-responsive.css below the marker "UNIQUE_MARKER: BP_PLAYER_CONTROLS"
			/*
			className={windowDimensions > 1239 - 21 ? classnames(classes.PlayerControls, { [classes.PlayerControlsShowControls]: page.isControlsVisible }) : classnames(classes.PlayerControlsResponsive, { [classes.PlayerControlsShowControls]: page.isControlsVisible })}
			*/
			// MTV-2528: Use video width for breakpoint (iPads in portrait mode have at least 768px)
			className={videoWidth >= 768 ? classnames(classes.PlayerControls, classes, { [classes.PlayerControlsShowControls]: page.isControlsVisible }) : classnames(classes.PlayerControlsResponsive, { [classes.PlayerControlsShowControls]: page.isControlsVisible })}
			// style={{ cursor: page.isControlsVisible && !page.isFullScreen ? "default" : "none" }}
			style={page.source.pauseAd && !page.isControlsVisible ? { pointerEvents: "none" } : {}}

			data-test="player_controls_wrapper"
			onClick={(e) => {
				if (e.target.closest(`#${ID_MAIN_CONTROLLER_CONTAINER} `)) return;
			}}
			onMouseMove={() => {
				// do nothing 
				// if the visibility of the controller is managed by the child component
				// in our case it is managed only from volume control
				if (!page.isControlsVisible) controlsTimerHandler(page)
			}
			}
		>
			{/* MTV-3398 Moved out of PlayerControlsWrapper */}
			{/* <div onDoubleClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
				<RecordingsManager ref={managerRecRef} oEvent={page.source?.Event} />
			</div> */}
			{/* CAUTION: Applying a change to below 2 breakpoint value requires also the same change in global-responsive.css below the marker "UNIQUE_MARKER: BP_PLAYER_CONTROLS" */}
			{/*
			{(page.isControlsVisible && windowDimensions > 1239 - 21) && (<PlayerControls classes={classes} page={page} managerRecRef={managerRecRef} ref={wrapperRef} />)}
			{(page.isControlsVisible && windowDimensions < 1240 - 21) && (<PlayerControlsResponsive classes={classes} page={page} managerRecRef={managerRecRef} ref={wrapperRef} />)}
			*/}
			{(page.isControlsVisible && videoWidth >= 768) && (<PlayerControls classes={classes} page={page} managerRecRef={managerRecRef} ref={wrapperRef} row3CenterFs={videoWidth > 1024 ? classes.PlayerControlsRow3CenterFullScreen : classes.PlayerControlsRow3CenterFullScreenDense} />)}
			{(page.isControlsVisible && videoWidth < 768) && (<PlayerControlsResponsive classes={classes} page={page} managerRecRef={managerRecRef} ref={wrapperRef} />)}
		</div>
	);
})

// button for close screen after full screen in tvguide
const PlayerCloseTvGuideScreen = CreateComponent(styles, false, true, ({ classes, page }) => {
	if (page.player.isMutedByBrowser === true) {
		// MTV-2525: don't hide mute icon
		controlsTimerHandler(page, true)
		return <PlayerMutedByBrowser classes={classes} page={page} />
	}
	//console.debug("PlayerCloseTvGuideScreen ctrlsVisible %o, onOverlay %s, !fs %s", page.isControlsVisible, page.isPlayerOnOverlay, !page.player.isFullScreen)
	return (
		<div
			data-test="player_close_tvguide"
			onClick={(e) => {
				if (e.target.closest(`#${ID_MAIN_CONTROLLER_CONTAINER} `)) return;
			}}
		>
			{page.isControlsVisible === true ?
				<div className={classes.PlayerControlsTopWrapper}>
					{page.isPlayerOnOverlay && !page.player.isFullScreen /*|| (page.isPlayerOnOverlay && page.player.isFullScreenCinema)*/ ?
						<LightTooltip title={l10n.featureTooltipClose} placement="bottom">
							<IconButton player={page.player}
								className={`${classes.PlayerControlsClose}`}
								onClick={(e) => {
									e.stopPropagation()
									EventEmitter.dispatch("closeOverlayDialog", null)
									page.player.setFullScreen(false, true).then(() => {
										page.player.setFullScreen(false)
									})
								}} data-test="player_close">
							</IconButton>
						</LightTooltip>
						: <></>}
				</div>
				: <></>
			}
		</div>
	)
})

/*
const PlayerCover = CreateComponent(null, false, true, ({ page, defaultCoverImg, ...props }) => (
	<CardMedia src={page?.source?.getPosterUrl ?? defaultCoverImg} component="img" data-test="player_cover" style={visibilityHelper(page.player.isPosterVisible)} {...props} />
))
*/
// MTV-3040: reenable with black poster image
const PlayerCover = CreateComponent(null, false, true, ({ page, defaultCoverImg, ...props }) => {
	//console.debug("isPosterVisible= %o %o %o %o %o", page.player.__path, page.player.isPosterVisible, page, defaultCoverImg)
	let visible = page?.player.isPosterVisible
	// MTVW-444: don't show cover if playerBg is in the background
	if (page.playerFg || page.isAdsPlayer) visible = false

	// MTVW-1094: PlayerCover for protected adult content
	const { handleProtectedClick, PinGuardElement } = useAdultPinGuard((channel) => {
		page.handleChangeChannel(channel?.id)
	})

	if (rootStore.channelsService?.isChannelPinProtected(page.source?.Event?.channel?.id)) {
		page.player.stopInstance()
		return (
			<>
				{PinGuardElement}
				<div style={{
					zIndex: 10,
					position: "absolute",
					display: "grid", 
					placeItems: "center",    // Centers children both horizontally and vertically
					alignContent: "center",  // Ensures the grid rows are centered vertically
					width: "100%",           // Force the div to be as wide as the parent
					height: "100%",          // Force the div to be as tall as the parent
					textAlign: "center",		 // Ensures text inside the div is also centered
					gap: "8px"}}
				>
					<img style={{ width: 60, height: 60}} src={PinLock}></img>
					<div style={{width: "100%", height: "100%", fontSize: 20, fontFamily: "EuropaBold"}}>
						{l10n.featureChannelPinProtected}
					</div>
					<div style={{marginTop: 20, cursor: "pointer"}}>
						<ButtonGeneric width="150px" variant="primary" label={l10n.featureSettingsAdultChannelUnlock}
							onClick={(e) => {
								if (e && e.stopPropagation) {
									//e.nativeEvent.stopImmediatePropagation()
									e.preventDefault()
									e.stopPropagation()
								}
								handleProtectedClick(page.source?.Event?.channel)}
							}
						/>
					</div>
				</div>
			</>
		)
	}

	return (
		// MTVW-725: capturedVideoImage
		//<CardMedia src={page?.source?.getPosterUrl ? defaultCoverImg : defaultCoverImg} component="img" data-test="player_cover" style={visibilityHelper(visible)} {...props} />
		<CardMedia src={page?.source?.capturedVideoImage ? page?.source?.capturedVideoImage : defaultCoverImg} component="img" data-test="player_cover" style={visibilityHelper(visible)} {...props} />
	)
})


// GT12-SVG trial
//async function getSvg(svg) {
//	/*
//	const response = await fetch(svg, {
//		method: 'GET', headers: { 'pragma': 'no-cache', 'cache-control': 'no-cache' }
//	})
//	const testSvg = await response.text()
//	console.debug("defaultCoverImg %o, testSvg %o, copy %s", defaultCoverImg, testSvg, svg.slice())
//	*/
//	//return testSvg
//	//return svg.slice()
//	const test = await import("img/PauseAd_McDonals_Spot_Test_AdLabeling.svg")
//	console.debug("IMPORT %o, default %o", test, test.default)
//	return test.default
//}

//const testSvg = getSvg("img/PauseAd_McDonals_Spot_Test_AdLabeling.svg")
//const testSvg = svgCoverImg

// NOTE: SVG doesn't start at the beginning when repeatedly played (browser cache)
// SVG has been postponed in favor of JPG
//return (
//	<div style={visibilityHelper(page.player.isPosterVisible)} {...props} >
//		<object type="image/svg+xml" data={page?.source?.getPosterUrl ? testSvg : testSvg} aria-label="Close" /*style={{ visibility: "hidden" }} {...props} */ />
//		{/*<CardMedia src={defaultCoverImg} type="image/svg+xml" data={defaultCoverImg} aria-label="Close" component="img" data-test="player_cover" style={visibilityHelper(page.player.isPosterVisible)} {...props} />*/}
//		{/*<img src={defaultCoverImg} alt="" data-test="player_cover" />*/}
//	</div>
//)
//})

const PlayerSurface = ({id, surfaceRef, videoId, visible, channelInfo, overlay = null, extra = null}) => {
	return (
		<div
			//ref={surfaceRef}
			//id={id}
			className="VideoLayout"
			style={getPlayerStyle(visible)}
			channel-info={channelInfo}
		>
			{/* surfaceRef and id go here with VideoBox, otherwise where it is commented above */}
			<div ref={surfaceRef} id={id} className="VideoBox">
				<div id="vjsHost" className="VjsHost" data-vjs-player>
					<video id={videoId} className="video-js" />
				</div>
				{overlay && (
				<div className="ReactOverlay">
					{overlay}
				</div>
				)}
			</div>

			{extra}
		</div>
	)
}

let hidePlayerControls = false
let clickTimer = null
let doubleClickTimer = null
let preventClick = false // differentiate between click and double click
const PlayerBodyInner = CreateComponent(styles, false, true, ({ classes, page, defaultCoverImg, playerName, managerRecRef }) => {
	//console.debug("container %o", page.player.container)

	// MTV-2504 don't need 2 useEffect function
	useEffect(() => {
		(async () => {
			console.debug("MOUNT %s, %o", playerName, page, page.player.isFullScreen)
			// MTVW-444, MTVW-788, MTVW-787
			page.mountEvent()
			setCurrentChannel(rootStore.channelsService.activeChannelId)
			let player = page.getPlayerByName(playerName)
			if (player) await player.setRefElemContainer(document.getElementById(page.player.domElementId.TV_PLAYER), true)
			player = page.getPlayerByName("playerBg")
			if (player) await player.setRefElemContainer(document.getElementById(page.player.domElementId.BG_PLAYER), true)
			player = page.getPlayerByName("playerAds")
			if (player) await player.setRefElemContainer(document.getElementById(page.player.domElementId.ADS_PLAYER), true)

			// MTV-2534: Add touch detection to show player controls
			const elem = document.getElementById("body_inner")
			if (elem) {
				elem.addEventListener("touchstart", tapOrClick, false)
				elem.addEventListener("touchmove", tapOrClick, false)
				elem.addEventListener("touchend", tapOrClick, false)
				// mouseup handler causes fullscreen / double tap issues
				//elem.addEventListener("mouseup", tapOrClick, false)
			}
			// MTV-2695: Special case for native controls on iOS
			const video = page.getVideoElem()
			if (video) {
				//video.addEventListener("webkitbeginfullscreen", webkitBeginFullScreen, false)
				video.addEventListener('webkitendfullscreen', webkitEndFullScreen, false)
				video.addEventListener('volumechange', volumeChange, false)
			}
			// MTVW-788, MTVW-787: tvRef, bgRef
			page.setTvRef(tvRef)
			page.setBgRef(bgRef)
		})()

		// Return a callback in useEffect and it will be called before unmounting.
		return () => {
			(async () => {
				console.debug("UNMOUNT %s, %o", playerName, page, page.player.isFullScreen)
				const elem = document.getElementById("body_inner")
				if (elem) {
					elem.removeEventListener("touchstart", tapOrClick, false)
					elem.removeEventListener("touchmove", tapOrClick, false)
					elem.removeEventListener("touchend", tapOrClick, false)
					//elem.removeEventListener("mouseup", tapOrClick, false)
				}
				const video = page.getVideoElem()
				if (video) {
					//video.removeEventListener("webkitbeginfullscreen", webkitBeginFullScreen, false)
					video.removeEventListener('webkitendfullscreen', webkitEndFullScreen, false)
					video.removeEventListener('volumechange', volumeChange, false)
				}

				// MTVW-708: Enable Ansehen button
				rootStore.page.OverlayEventDetails.setPlayEventStarted(false)
				// GT12
				// MTVW-444, MTVW-788, MTVW-787
				page.mountEvent()
				let player = page.getPlayerByName(playerName)
				try {
					if (player) await player.setRefElemContainer(null, true)
				}
				catch (e) {
					console.error("~useEffect", e)
				}
				// MTVW-444
				player = page.getPlayerByName("playerBg")
				if (player) await player.setRefElemContainer(null, true)
				player = page.getPlayerByName("playerAds")
				if (player) await player.setRefElemContainer(null, true)
			})()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// MTVW-633: check for _refElemContainer, it could be set to null after an error condition
	useEffect(() => {
		const player = page.getPlayerByName(playerName)
		//console.warn("useEffect checking", playerName)
		setCurrentChannel(rootStore.channelsService.activeChannelId)
		if (!player?._refElemContainer) console.warn("useEffect null check", playerName, player, player._refElemContainer)

		/* MTVW-444, MTVW-788, MTVW-787: causes garbage if pausing live stream and immediately skipping back 10 seconds
		if (!player?._refElemContainer) {
			//(async () => {
			// MTVW-444, MTVW-788, MTVW-787
			page.mountEvent()
			page.getPlayerByName(playerName).setRefElemContainer(document.getElementById(page.player.domElementId.TV_PLAYER), true)
			// MTVW-444
			page.getPlayerByName("playerBg").setRefElemContainer(document.getElementById(page.player.domElementId.BG_PLAYER), true)
			page.getPlayerByName("playerAds").setRefElemContainer(document.getElementById(page.player.domElementId.ADS_PLAYER), true)
			// MTVW-788, MTVW-787: tvRef, bgRef
			page.setTvRef(tvRef)
			page.setBgRef(bgRef)
			//})()
		}*/
	})

	const [currentChannel, setCurrentChannel] = useState(null)
	// MTVW-788, MTVW-787: tvRef, bgRef
	const playerRootRef = useRef()
	const tvRef = useRef()
	const bgRef = useRef()
	const adsRef = useRef()

	// MTVW-633: check for _refElemContainer, it could be set to null after an error condition
	/*
	useLayoutEffect(() => {
		const player = page.getPlayerByName(playerName)
		setCurrentChannel(rootStore.channelsService.activeChannelId)
		if (!player?._refElemContainer && rootStore.channelsService.activeChannelId) {
			//(async () => {
				console.debug("useEffect activeChannelId", player._refElemContainer, rootStore.channelsService.activeChannelId)
				page.getPlayerByName(playerName).setRefElemContainer(document.getElementById(page.player.domElementId.TV_PLAYER))
				page.getPlayerByName("playerAds").setRefElemContainer(document.getElementById(page.player.domElementId.ADS_PLAYER))
			//})()
		}
	}, [rootStore.channelsService.activeChannelId])
	*/

	/*
	function webkitBeginFullScreen(event) {
		event.preventDefault()
		event.stopPropagation()
		//console.debug("webkitBeginFullScreen")
	}
	*/

	// special case for iOS with native controls to close the fullscreen player
	function webkitEndFullScreen(event) {
		console.debug("webkitEndFullScreen paused %s by user %s", page.player.isPaused, page.player.isPausedUser)
		event.stopPropagation()
		event.preventDefault()
		page.player.setFullScreen(false)
		// The native player pauses video if it's closed, we need to apply a delay to start play again
		if (!page.player.isPausedUser) {
			setTimeout(() => {
				page.player.setPlay("webkitEndFullScreen")
			}, 600)
		}
	}

	// special case for iOS with native controls to handle mute / unmute
	function volumeChange(event) {
		const video = page.getVideoElem()
		//console.debug("volumeChange %o muted %s", event, video.muted)
		if (video) page.player.setMuteState(video.muted)
	}

	function tapOrClick(event) {
		if (rootStore.page.Player.settings.isOnDiscover) return
		// PIN PROTECTION CASE, IMPORTANT in responsive mode!
		if (rootStore.channelsService?.isChannelPinProtected(page.source?.Event?.channel?.id)) return
		//The code below blocks the appearance of the controls after pressing the play button in the middle of the screen
		if (hidePlayerControls && event.type === "touchend") {
			hidePlayerControls = false
			return
		}

		if (page.isControlsVisible && (event.target.id === ID_MAIN_CONTROLLER_CONTAINER || event.target.id.includes(ID_PLAYER_CONTROLLER_RESPONSIVE))) {
			page.setMouseOver(false)
		}
		//console.debug("touch %o type %s visible %s", event, event.type, page.isControlsVisible)
		if (event.type === "touchend") {
			// GT12
			if (clickTimer === null) {
				clickTimer = setTimeout(function () {
					clickTimer = null;
					// display player controls
					controlsTimerHandler(page)
					//console.debug("single")
				}, 500)
			} else {
				clearTimeout(clickTimer);
				clickTimer = null;
				// MTVW-424: for full screen with double touch
				preventClick = true;
				//console.debug("preventClick true tapOrClick")
				//console.debug("double")
				event.preventDefault()
				if (!page.isControlsVisible) {
					page.player.setFullScreen(null)
					// hide controls
					controlsTimerHandler(page, true)
					setTimeout(() => {
						page.setMouseOver(false)
					}, 100)
				}
			}
		}

		if (event.type === "touchmove") {
			if (!page.isControlsVisible) {
				// ignore event, it would generate onMouseMove event which enables the player controls
				event.preventDefault()
			}
		}

		if (!page.isControlsVisible) {
			if (page.error === null) {

				if (page.source.adState.isAdActive) {
					//event.preventDefault()
					page.setMouseOver(false)
					return
				}
				event.preventDefault()
				//event.stopPropagation()
				// don't show controls
				//controlsTimerHandler(page)
			}
		}
		//return false
	}

	function doClickAction() {
		// MTV-1811: prevent playing of non subscribed channel in case there is an error
		// MTV-3583: handle click event for fixing new click away issue introduced with React 17
		// if the menu is open the event will be stopped in ClickAwayListener of the player controller
		// PIN PROTECTION CASE, IMPORTANT in responsive mode!
		if (page.error === null && !rootStore.channelsService?.isChannelPinProtected(page.source?.Event?.channel?.id)) {
			// MTVW-424: condition to handle play icon in the middle of the screen in both player
			// GT12: condition with pauseAd, otherwise pause would be resumed when in OverlayEventDetails
			//console.debug("doClickAction isInPip", page.player.isInPip, page.player)
			// MTVW-727: isInPip
			if (!subTitleOpen && !page.player.isInPip) {
				void page.source.setPlayPause()
			}
		}
	}

	function doDoubleClickAction() {
		// MTVW-727: isInPip
		if (page.player.isInPip) return
		page.player.setFullScreen(null)
		// hide controls
		controlsTimerHandler(page, true)
		setTimeout(() => {
			page.setMouseOver(false)
		}, 100)
	}

	const middleScreenPlayButton = (<IconButton className={isPhoneSize() ? ` ${classes.centralPlayResumeButtonMobile} ` : ` ${classes.centralPlayResumeButton} `} alt="" //style={page.source.pauseAd ? { zIndex: 2 } : { zIndex: 4 }}
		id="middleScreenPlayButton"
		onClick={(e) => {
			e.stopPropagation()
			e.preventDefault()
			doClickAction()
		}}
		onTouchStart={e => {
			e.stopPropagation()
			e.preventDefault()
			page.setMouseOver(false)
			// the variable above will be checked in tapOrClick
			// need only in touchStart
			hidePlayerControls = true
		}}
		onTouchEnd={(e) => {
			e.stopPropagation()
			e.preventDefault()
			page.setMouseOver(false)
			doClickAction()
		}}
	/>)
	//console.debug("PLAYER %s, path %s", playerName, page?.player?.__path)
	//const list = document.getElementsByTagName("video")
	//console.debug("VIDEOS %o", list/*.namedItem("")*/)
	return (
		<>
			{/*console.debug("currentChannel", currentChannel)*/}
			<div id="body_inner" className={classes.PlayerWrapper + " PlayerWrapperResponsive"} >
				<div className={classes.Player}
					// show and hide <PlayerControlsWrapper>
					onMouseMove={() => {
						if (!page.source.pauseAd) {
							controlsTimerHandler(page)
						}
					}}
					onDoubleClick={(e) => {
						e.stopPropagation()
						e.preventDefault()
						clearTimeout(doubleClickTimer)
						// MTVW-452: 
						// added if condition to fix the issue of opening fullscreen with double touch on iPad
						if (!preventClick) {
							// VJS: prevent initial fullScreen when double clicked on poster play button to start video
							if (!page.player._isStreamLoaded) return
							preventClick = true;
							//console.debug("preventClick true onDoubleClick")
							doDoubleClickAction()
						}
					}}
					onClick={(e) => {
						// prevent play pause when releasing drag above thumbnail
						if (page.dragOnProgressBar) return
						// PIN PROTECTION CASE, IMPORTANT in responsive mode!
						if (rootStore.channelsService?.isChannelPinProtected(page.source?.Event?.channel?.id)) return
						// MTV-3583: handle click event for fixing new click away issue introduced with React 17
						// setTimeout to give time to close the menu
						setTimeout(() => { subTitleOpen = false }, 500)
						setTimeout(() => {
							e.stopPropagation()
						}, 600)
						e.preventDefault()
						doubleClickTimer = setTimeout(function () {
							if (!preventClick) {
								doClickAction()
							}
							//console.debug("preventClick false onClick")
							preventClick = false;
						}, 300);
					}}
				>
					{console.debug("defaultCoverImg", defaultCoverImg)}
					<CardMedia src={defaultCoverImg} component="img" className={classes.PlayerDefaultCover} />
					{/* MTV-2172: Move controls inside tvPlayer */}
					{/* GT12
					<div id="tvPlayer" ref={el => { page.getPlayerByName(playerName).setRefElemContainer(el) }} className={classes.PlayerBody}></div>
					*/}
					{/*
					// MTVW-733: addedd style for ultrawidescreen fix
					<div id="uiPlayers" className={classes.PlayerBody} style={isIphone() || isIpad() ? {} : { objectFit: "contain", height: "100%", paddingTop: "0px" }}>
					*/}
					{/*console.debug("activePlayer=", page.player._refElemContainer?.id)*/}
					<div id="uiPlayers" className={classes.PlayerBody} /*style={{ objectFit: "contain", height: "100%", paddingTop: "0px" }}*/>
						<div id="playerRoot" ref={playerRootRef} className="PlayerRoot">
							{/* MTV-3617: move PlayerCover into this "tvPlayer" div */}
							{/* MTV-3040: reenable with black poster image */}
							<PlayerCover page={page} defaultCoverImg={defaultCoverImg} className={classes.PlayerCover} />
							<PauseAd page={page} classes={classes} />
							<div className={classes.SpinnerContainer}>
								{/*<PlayerLoading classes={classes} player={page.getPlayerByName("playerBg")} />*/}
								<PlayerLoading classes={classes} player={page.getPlayerByName(playerName)} />
							</div>
							{/* MTVW-452 */}
							{/* <div id="tvPlayer" /*className={classes.PlayerBody} style = {{  */}
							{/* TV PLAYER */}
							<PlayerSurface
								id={page.player.domElementId.TV_PLAYER}
								surfaceRef={tvRef}
								videoId={`vjs_${playerName}`}
								visible={true}
								channelInfo={currentChannel}
								overlay={
									<div id="ctrlsTvPlayer">
										{(page.player._refElemContainer?.id !== page.player.domElementId.BG_PLAYER) &&
											<>
											<PlayerControlsWrapper
												page={page}
												classes={classes}
												managerRecRef={managerRecRef}
											/>
											<PositionStateMonitorUi
												page={page}
												adStyleValidCounter={page.player?.__parent?.adStyleValidCounter}
												adStyleInfo={page.player?.__parent?.adStyleInfo}
												isControlsVisible={page.isControlsVisible}
												isFullScreen={page.player.isFullScreen}
												isFullScreenCinema={page.player.isFullScreenCinema}
											/>
											</>
										}
									</div>
								}
								/*extra={<div id="imscContainer" className="ImscContainer" />}*/
							/>
							{/* MTVW-444*/}
							{/* BG PLAYER */}
							<PlayerSurface
								id={page.player.domElementId.BG_PLAYER}
								surfaceRef={bgRef}
								videoId="vjs_playerBg"
								visible={false}
								channelInfo={currentChannel}
								overlay={
									<div id="ctrlsBgPlayer">
										{(page.player._refElemContainer?.id === page.player.domElementId.BG_PLAYER) &&
											<>
											<PlayerControlsWrapper
												page={page}
												classes={classes}
												managerRecRef={managerRecRef}
											/>
											<PositionStateMonitorUi
												page={page}
												adStyleValidCounter={page.player?.__parent?.adStyleValidCounter}
												adStyleInfo={page.player?.__parent?.adStyleInfo}
												isControlsVisible={page.isControlsVisible}
												isFullScreen={page.player.isFullScreen}
												isFullScreenCinema={page.player.isFullScreenCinema}
											/>
											</>
										}
									</div>
								}
								/*extra={<div id="imscContainer" className="ImscContainer" />}*/
							/>
							{/* MTVW-452 - MTVW-453 */}
							{/* GT12 ADS PLAYER */}
							<PlayerSurface
								id={page.player.domElementId.ADS_PLAYER}
								surfaceRef={adsRef}
								videoId="vjs_playerAds"
								visible={false}
								channelInfo={currentChannel}
								overlay={
									<>
										{page.source.player.isPausedUser && middleScreenPlayButton}

										{page.source.adState?.fastFwd && (
											<AdCounter
												page={page}
												adStyleValidCounter={page.player?.__parent?.adStyleValidCounter}
												adStyleInfo={page.player?.__parent?.adStyleInfo}
												isFullScreen={page.player.settings.isFullScreen}
											/>
										)}

										{page.source.adState?.replay && (
											<AdCounter
												page={page}
												adStyleValidCounter={page.player?.__parent?.adStyleValidCounter}
												adStyleInfo={page.player?.__parent?.adStyleInfo}
												isFullScreen={page.player.settings.isFullScreen}
											/>
										)}

										{/* NEEDED? */}
										{/*
										<PositionStateMonitorUi
											page={page}
											adStyleValidCounter={page.player?.__parent?.adStyleValidCounter}
											adStyleInfo={page.player?.__parent?.adStyleInfo}
											isControlsVisible={page.isControlsVisible}
											isFullScreen={page.player.isFullScreen}
											isFullScreenCinema={page.player.isFullScreenCinema}
										/>
										*/}
									</>
								}
								/*extra={<div id="imscContainer" className="ImscContainer" />}*/
							/>
							<div id="imscContainer" className="ImscContainer" />
						</div>
						{/* MTVW-444: moved from div TV_PLAYER and div BG_PLAYER */}
						{/*<PlayerControlsWrapper page={page} classes={classes} managerRecRef={managerRecRef} />*/}
						<PlayerCloseTvGuideScreen page={page} classes={classes} />
						{/* GT12 fastForward */}
						{/*page.source.adState?.linear ? console.debug("AD_LINEAR skip %s", page.source.adState.linear.skip) : null*/}
						{/* MTVW-444: end moved from */}
					</div>
					{/* MTV-3617: move PlayerCover into div "tvPlayer" above */}
					{/*
					<PlayerCover page={page} defaultCoverImg={defaultCoverImg} className={classes.PlayerCover} />
					*/}
				</div>
				{/* MTV-3617: move PlayerLoading into div "tvPlayer" above */}
				{/*
				<PlayerLoading classes={classes} player={page.getPlayerByName(playerName)} />
				*/}
				{/*
				{!(page.error?.isError || rootStore.page.Recordings.Manager.oRecEvent.error) ? <PlayerControlsWrapper page={page} classes={classes} /> : <></>}
				*/}

				{/* MTV-2172: Move controls inside tvPlayer
				<PlayerControlsWrapper page={page} classes={classes} />
				<PlayerCloseTvGuideScreen page={page} classes={classes} />
				*/}
			</div>
		</>
	)
})

const PlayerBodyInnerEmpty = CreateComponent(styles, false, true, ({ classes, page, defaultCoverImg, playerName, managerRecRef }) => {
	return (
		<div id="body_inner" className={classes.PlayerWrapper + " PlayerWrapperResponsive"} >
			<div className={classes.Player}>
			</div>
			<CardMedia src={defaultCoverImg} component="img" className={classes.PlayerDefaultCover} />
			<div id="uiPlayers" className={classes.PlayerBody}>
				<div id="tvPlayer" style={getPlayerStyle(true)} channel-info="">
					{/*<PlayerControlsWrapper page={page} classes={classes} managerRecRef={managerRecRef} />*/}
					<PlayerCover page={page} defaultCoverImg={defaultCoverImg} className={classes.PlayerCover} />
				</div>
				<div id="adsPlayer" className={classes.adsPlayerBody} style={getPlayerStyle(false)}
					data-test={`${page.player.isFullScreen ? 'ads_player_full_screen' : 'ads_player_not_full_screen'}`}
				>
				</div>
			</div>
		</div>
	)
})


export const PlayerBody = CreateComponent(styles, false, true, ({ classes, page, defaultCoverImg, playerName, managerRecRef }) => {
	return (
		<>
			{/*<div id="ql_player_container" className={classes.PlayerContainer}*/}
			<div id="ql_player_container" className={classnames(classes.PlayerContainer, { [classes.PlayerFullscreen]: page.player.isFullScreen })}
				data-test={page.player.isFullScreen ? "player_container_maximized" : "player_container_minimized"}
			>
				{/*
	{page.player.isFullScreen ? console.debug("container full %o", page.player.container) : console.debug("container min %o", page.player.container)}
	*/}
				{/* MTVW-727b: could be an option to go back to live TV without starting new stream
				{!page.remount && !page.player.isInPip ? */}
				{!page.remount ?
					<PlayerBodyInner classes={classes} page={page} defaultCoverImg={defaultCoverImg} playerName={playerName} managerRecRef={managerRecRef} />
					//: null
					: <PlayerBodyInnerEmpty classes={classes} page={page} defaultCoverImg={defaultCoverImg} playerName={playerName} managerRecRef={managerRecRef} />
				}
			</div>
		</>
	)
})

export const Player = CreateComponent(null, false, false, ({ ...props }) => {
	// props contain defaultCoverImg
	const page = useRootStore().page.Player
	// MTV-3671: move ref to here
	const managerRecRef = useRef()
	const fsState = useRef(page.player.isFullScreen)

	//console.debug("--->>>>>>>>>>>>>> Player Player.js 1520" + page.isLoading + ' ' + rootStore.page.Player?.player?.isLoading)
	useEffect(...page.getMountBody(() => { }))
	useEffect(() => {
		// MTV-1532: fix Changing a channel while the current running channel is on pause, the new channel is also paused
		// MTV-3746: iPhone / iPad generates VO_OSMP_CB_PLAY_PAUSED event when the app is put into background, use isPausedUser instead of isPaused
		//console.debug("useEffect isPausedUser %s, %s, %s", page.player.isPausedUser, page.player.positionTimeStamp, page.player.activePosition)
		// MTVW-217: add condition for inactiveReason - DISABLED in PlayerVo
		// GT12: condition with pauseAd, otherwise pause would be resumend when in OverlayEventDetails
		// MTVW-444: && !page.playerFg
		// MTVW-1166, MTVW-465: added check for full screen change and showing event details via info button in liveTv
		if (fsState.current === page.player.isFullScreen && !(rootStore.page?.OverlayEventDetails?.isShow && page.isInLiveTv)) {
			//console.debug("opening Player useEffect", page.player.isFullScreen, props, page.player.isPausedUser, page.player.inactiveReason, !page.source.pauseAd, !page.playerFg)
			if (page.player.isPausedUser && (page.player.inactiveReason === null) && !page.source.pauseAd && !page.playerFg) {
				page.source.setPlayPause()
			}
		}
		else {
			//console.debug("opening Player fsState", page.player.isFullScreen)
			fsState.current = page.player.isFullScreen
		}
	}, [page.player.isPausedUser, page.player.inactiveReason, page.source, page.player.isFullScreen])

	useEffect(() => {
		page.initPlayerControls(page.player.domElementId.TV_PLAYER)
		// MTVW-444
		page.initPlayerControls(page.player.domElementId.BG_PLAYER)
	}, [page])

	return (
		<>
			{/* MTV-2504: A double click on the REC button needs to be disabled here */}
			{/* MTV-3671: below div moved to here to fix black screen at end of playback caused by RecordingsManager (MTV-3398) */}
			<div id="player-rec-wrapper" onDoubleClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
				<RecordingsManager ref={managerRecRef} oEvent={page.source?.Event} />
			</div>
			<PlayerBody page={page} playerName="playerLiveTvVo" managerRecRef={managerRecRef} {...props} />
		</>
	)
})
